import {
  of as observableOf,
  concat as observableConcat,
  merge as observableMerge,
  fromEvent as observableFromEvent,
  zip as observableZip,
  Observable,
  Subject
} from 'rxjs';
import { toArray, debounceTime } from 'rxjs/operators';
import { UnitHelper } from './../common/unit.helper';
import { PointloadsComponent } from './pointloads/pointloads.component';
import { LineloadsComponent } from './lineloads/lineloads.component';
import { UserService } from './../service/common/user.service';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef, ViewChildren } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControlName,
  ValidatorFn,
  AbstractControl
} from '@angular/forms';
import { SharedService } from '../service/common/shared.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import * as _ from 'lodash';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { ProjectService } from '../project/project.service';
import { SubProjectService } from './sub-project.service';
import * as models from './../models/models';
import { CalculateComponent } from './../calculations/calculate/calculate.component';
import { CalculationsService } from './../calculations/calculations.service';
import { SessionStorageService } from './../service/util/session-storage.service';
import { AppConstants } from '../common/AppConstants';
import { CustomValidators } from 'ng2-validation';
import { TranslateService } from '@ngx-translate/core';
import { NavService, INavItem } from '../service/common/nav.service';
import * as FileSaver from 'file-saver';
import { ConfigService } from 'app/service/config.service';
import { ApplicationOptionsService } from 'app/service/common/application-options.service';

@Component({
  selector: 'app-subproject',
  templateUrl: './sub-project.component.html',
  styleUrls: ['./sub-project.component.scss']
})

export class SubProjectComponent implements AfterViewInit, OnDestroy, OnInit {

  public static DEFAULT_STEEL_PROFILE_NAME = 'IPE 100';
  public static DEFAULT_LOAD = 1;
  public static DEFAULT_ID = 1;
  public static DEFAULT_LIVELOAD_PERCENT_ID = 3;
  public static GENERAL = 0;
  public static BEAM_GEOMETRY = 1;
  public static MATERIAL = 2;
  public static SLAB = 3;
  public static LOADS = 4;
  public static ADDITIONAL_LOADS = 5;
  public static CONNECTOR = 6;
  public static DEFORMATION = 7;
  public static CALCULATE = 8;
  public static ADDITIONAL_LOAD_DRAWING_WIDTH = 400;
  public static LOAD_DRAWING_WIDTH = 450;
  public static DRAWING_WIDTH = 450;
  public static DRAWING_HEIGHT = 300;
  public static LOAD_DRAWING_HEIGHT = 100;
  public static DEFAULT_CONCRETE_CLASS_ID = 2;
  public static DEFAULT_LIVE_LOAD_DEFL_ID_EURO = 6;
  public static DEFAULT_LIVE_LOAD_DEFL_ID_AMERICAN = 13;
  public static DEFAULT_LIVE_LOAD_DEFL_ID_AUNZ = 19;
  public static DEFAULT_DAMPLING_ID_US = 1;
  public static DEFAULT_DAMPLING_ID_ASNZS = 6;
  public static DEFAULT_DEFLECTION_LIMIT_ID_EURO = 4;
  public static DEFAULT_DEFLECTION_LIMIT_ID_AMERICAN = 12;
  public static DEFAULT_DEFLECTION_LIMIT_ID_AUNZ = 17;
  public static DEFAULT_STEELGRADE_ID_EURO = 1;
  public static DEFAULT_REINFORCEMENT_ID_EURO = 1;
  public static DEFAULT_CONSTRUCTIONTYPE_ID_EURO = 1;
  public static DEFAULT_STEELGRADE_ID_US = 5;
  public static DEFAULT_REINFORCEMENT_ID_US = 5;
  public static DEFAULT_CONSTRUCTIONTYPE_ID_US = 3;
  public static DEFAULT_STEELGRADE_ID_AU = 13;
  public static DEFAULT_STEELGRADE_ID_NZ = 13;
  public static DEFAULT_REINFORCEMENT_ID_AUNZ = 7;
  public static DEFAULT_CONSTRUCTIONTYPE_AUNZ = 5;
  public static DEFAULT_UNIT_SYSTEM = 1;
  public static DEFAULT_STEELGRAGE_META_ID = 8;
  public static META_COUNTRIES = [22, 24, 19, 23, 21, 40, 41, 42, 43, 44];
  public static DEFAULT_PROFILE_ASNSZ = 'Dimond Structural - Flatdeck 0.75';
  public static CUSTOM_CONCRETE_METRIC = {
    min: 21,
    maxNormal: 50,
    maxLight: 41
  };
  public static CUSTOM_CONCRETE_IMPERIAL = {
    min: 3000,
    maxNormal: 7250,
    maxLight: 6000
  };
  public static CUSTOM_CONCRETE_ASNZS = {
    min: 20,
    max: 50
  };
  public static CUSTOM_STEELGRADE_YIELD_STRENGTH_METRIC = {
    min: 170,
    max: 355
  };
  public static CUSTOM_STEELGRADE_YIELD_STRENGTH_IMPERIAL = {
    min: 25,
    max: 50
  };
  public static PROFILED_SHEETING_CUSTOM_YIELD_STRENGTH_METRIC = {
    min: 170,
    max: 600
  };
  public static PROFILED_SHEETING_CUSTOM_YIELD_STRENGTH_IMPERIAL = {
    min: 25,
    max: 85
  };
  public static CONCRETE_DENSITY_METRIC = {
    min: 1750,
    max: 2500
  };
  public static CONCRETE_DENSITY_IMPERIAL = {
    min: 90,
    max: 155
  };
  public static CONCRETE_DENSITY_ASNZS = {
    min: 1750,
    max: 2800
  };
  public static CONCRETE_DENSITY_AGGREGATES_METRIC = {
    min: 1400,
    max: 2000
  };
  public static CONCRETE_DENSITY_AGGREGATES_IMPERIAL = {
    min: 90,
    max: 125
  };
  public static CONCRETE_DENSITY_AGGREGATES_ASNZS = {
    min: 1400,
    max: 2000
  };
  public static BEAM_LENGTH_METRIC = {
    min: 2,
    max: 20
  };
  public static BEAM_LENGTH_IMPERIAL = {
    min: 1.64,
    max: 66
  };
  public static BEAM_SPACING_EDGE_METRIC_MIN = 0.5;
  public static BEAM_SPACING_INTERMEDIATE_METRIC_MIN = 0.15;
  public static BEAM_SPACING_EDGE_IMPERIAL_MIN = 1.64;
  public static BEAM_SPACING_INTERMEDIATE_IMPERIAL_MIN = 0.49;
  public static STEEL_PROFILE_CUSTOM_HEIGHT_METRIC = {
    min: 100,
    max: 1120
  };
  public static STEEL_PROFILE_CUSTOM_HEIGHT_IMPERIAL = {
    min: 4,
    max: 44
  };
  public static STEEL_PROFILE_CUSTOM_ROOT_RADIUS_METRIC = {
    min: 0,
    max: 30
  };
  public static STEEL_PROFILE_CUSTOM_ROOT_RADIUS_IMPERIAL = {
    min: 0,
    max: 1.2
  };
  public static PROFILED_SHEETING_CUSTOM_DECK_DEPTH_METRIC = {
    min: 30,
    max: 80
  };
  public static PROFILED_SHEETING_CUSTOM_DECK_DEPTH_IMPERIAL = {
    min: 1,
    max: 3
  };
  public static PROFILED_SHEETING_CUSTOM_BOTTOM_WIDTH_METRIC = {
    min: 30,
    max: 400
  };
  public static PROFILED_SHEETING_CUSTOM_BOTTOM_WIDTH_IMPERIAL = {
    min: 1,
    max: 16
  };
  public static PROFILED_SHEETING_CUSTOM_TOP_WIDTH_METRIC = {
    min: 30,
    max: 400
  };
  public static PROFILED_SHEETING_CUSTOM_TOP_WIDTH_IMPERIAL = {
    min: 1,
    max: 16
  };
  public static PROFILED_SHEETING_CUSTOM_TROUGHSPACING_METRIC = {
    min: 100,
    max: 600
  };
  public static PROFILED_SHEETING_CUSTOM_TROUGHSPACING_IMPERIAL = {
    min: 4,
    max: 24
  };
  public static PROFILED_SHEETING_CUSTOM_RIB_STIFFENER_WIDTH_METRIC = {
    min: 0,
    max: 50
  };
  public static PROFILED_SHEETING_CUSTOM_RIB_STIFFENER_WIDTH_IMPERIAL = {
    min: 0,
    max: 2
  };
  public static PROFILED_SHEETING_CUSTOM_STIFFENERS_SPACING_METRIC = {
    min: 0,
    max: 200
  };
  public static PROFILED_SHEETING_CUSTOM_STIFFENERS_SPACING_IMPERIAL = {
    min: 0,
    max: 8
  };
  public static STEEL_PROFILE_CUSTOM_WEB_THICKNESS_METRIC = {
    min: 3
  };
  public static STEEL_PROFILE_CUSTOM_WEB_THICKNESS_IMPERIAL = {
    min: 0.125
  };
  public static STEEL_PROFILE_CUSTOM_FLANGE_WIDTH_METRIC = {
    min: 6
  };
  public static STEEL_PROFILE_CUSTOM_FLANGE_WIDTH_IMPERIAL = {
    min: 0.22
  };

  public static CONCRETE_STRENGTH_US_METRIC = 21;
  public static CONCRETE_STRENGTH_US_IMPERIAL = 3000;

  public static DEFAULT_WALKING_ACTIVITY = 1;
  public static DEFAULT_RHYTMIC_ACTIVITY = 1;
  private _saveOnLeaveSubject: Subject<boolean> = new Subject<boolean>();
  public $saveOnLeaveObs = this._saveOnLeaveSubject.asObservable();
  public showSaveOnDestroyDialog = false;

  @ViewChild(CalculateComponent, { static: false })
  public calculateComponent: CalculateComponent;
  @ViewChild(LineloadsComponent, { static: false })
  public lineloadsComponent: LineloadsComponent;
  @ViewChild(PointloadsComponent, { static: false })
  public pointloadsComponent: PointloadsComponent;
  @ViewChild(TabStripComponent, { static: true })
  public tabstripComponent: TabStripComponent;
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[] = [];

  public project: models.Project;
  private subProjectModel: models.SubProject = <models.SubProject>{};
  public surfaceLiveLoadsDrawing = '';
  public standardLoadDrawing0 = '';
  public standardLoadDrawing1 = '';
  public standardLoadDrawing2 = '';
  public liveLineLoadsDrawing = '';
  public livePointLoadsDrawing = '';
  public deadLineLoadsDrawing = '';
  public deadPointLoadsDrawing = '';
  public compositeCrossSectionDrawing = '';
  public slabDrawing1 = '';
  public slabDrawing2 = '';
  public beamLoadDrawing = '';
  public beamLoadDrawing1 = '';
  public compositeBeamDrawing = '';
  public steelSectionDrawingStream1 = '';
  public steelSectionDrawingStream2 = '';
  public beamGeometryDrawingStream = '';
  public profiledSheetingDrawing = '';
  public steelProfilesPerRange: any[] = [];
  public concreteClassesPerConcreteType: any[] = [];
  public beamLocationB1Text: string;
  public beamLocationB2Text: string;
  public beamLocationB1Error: string;
  public beamLocationB2Error: string;
  public displayMessage: { [key: string]: string } = {};
  public validationMessages: { [key: string]: { [key: string]: string } };
  public beamLocations: any[] = [];
  public beamTypes: any[] = [];
  public nationalAnnexes: any[] = [];
  public loadCategories: any[] = [];
  public combinationFactors: any[] = [];
  public partialFactors: any[] = [];
  public beamDesigns: any[] = [];
  public slabTypes: any[] = [];
  public profileTypes: any[] = [];
  public steelprofiles: any[] = [];
  public steelGrades: any[] = [];
  public steelStandards: models.SteelStandards[] = [];
  public concreteTypes: any[] = [];
  public concreteClasses: any[] = [];
  public concreteStrengths: any[] = [];
  public reinforcementSteelGrades: any[] = [];
  public sheetingOrientations: any[] = [];
  public profileSheetings: any[] = [];
  public shearConnectionDegrees: any[] = [];
  public shearConnectorOrientations: any[] = [];
  public shearConnectorTypes: any[] = [];
  public deflectionLimits: any[] = [];
  public totalDeflectionLimits: any[] = [];
  public liveLoadPercentages: any[] = [];
  public totalLoadDeflections: any[] = [];
  public constructionTypes: models.ConstructionOption[] = [];
  public subProjectForm: FormGroup;
  public dropDownOptions: models.Options;
  public calculatedSelfWeightNewtons: number;
  public calculatedLiveLoadNewtons: number;
  public calculatedSelfWeightDisplay: number;
  public calculatedLiveLoadDisplay: number;
  public projectId = 0;
  public subProjectId = 0;
  public saveError: boolean;
  public calculateError: boolean;
  public selectedTab: number;
  public selectedSteelProfile: models.SteelProfile;
  public overrideSelfWeight: boolean;
  public overrideLiveLoad: boolean;
  public partialFactor: models.PartialFactor;
  public filteredConnectorTypes: any[];
  public filteredConnectorOrientations: any[];
  public isNew = false;
  public showSaveAsSubProjectDialog = false;
  public saveAsSubProjectName = '';
  public enableReportButton = true;
  public calculateInput: models.Calculate.CreateCommand;
  public subProjects: Array<any>;
  public displayCoverRequiredYes = false;
  public displayCoverRequiredNo = false;
  public displayWalkingExitationNote = false;
  public calculationResponse: models.Calculate.CalculationResult;
  public appVersion: models.Version;
  public disableCreateButton = false;
  public hideAdditionalLoad = true;
  public forceFactor: number;
  public unitSystem: models.UnitSystem = <models.UnitSystem>{};
  public unit: number;
  public gages: models.UsGage[] = [
    { gage: 26, inch: 0.01875 },
    { gage: 24, inch: 0.025 },
    { gage: 22, inch: 0.03125 },
    { gage: 20, inch: 0.0375 },
    { gage: 18, inch: 0.05 },
    { gage: 16, inch: 0.0625 },
  ];


  public damplings: models.Damplings[] = [];
  public walkingActivity: models.Option<number>[] = [];
  public rhythmicActivity: models.Option<number>[] = [];

  public validationValues = {
    'steelProfileCustomSteelGradeYieldStrength': {
      'min': null,
      'max': null
    },
    'concreteDensityRange': {
      'min': null,
      'max': null
    },
    'concreteDensityAggregatesRange': {
      'min': null,
      'max': null
    },
    'customDefinedConcreteRange': {
      'min': null,
      'max': null
    },
    'beamLengthRange': {
      'min': null,
      'max': null
    },
    'beamSpacingLeft': {
      'min': null,
      'max': null
    },
    'beamSpacingRight': {
      'min': null,
      'max': null
    },
    'profiledSheetingCustomYieldStrength': {
      'min': null,
      'max': null
    },
    'steelProfileCustomHeight': {
      'min': null,
      'max': null
    },
    'steelProfileCustomRootRadius': {
      'min': null,
      'max': null
    },
    'profiledSheetingCustomDeckDepth': {
      'min': null,
      'max': null
    },
    'profiledSheetingCustomBottomWidth': {
      'min': null,
      'max': null
    },
    'profiledSheetingCustomTopWidth': {
      'min': null,
      'max': null
    },
    'profiledSheetingCustomTroughSpacing': {
      'min': null,
      'max': null
    },
    'profiledSheetingCustomRibStiffenerWidth': {
      'min': null,
      'max': null
    },
    'profiledSheetingCustomStiffenersSpacing': {
      'min': null,
      'max': null
    },
    'steelProfileCustomWebThickness': {
      'min': null
    },
    'steelProfileCustomFlangeThickness': {
      'min': null
    }
  };

  // subjects
  private drawCompositeSubject: Subject<any>;
  private isFormValidSubject: Subject<any>;

  public DEFAULT_DROPDOWNS = {
    beamDesignId: 1,
    beamLocationId: 1,
    steelProfileTypeId: 1,
    steelGradeId: 1,
    concreteTypeId: 1,
    concreteDensityId: 1,
    constructionTypeId: 1,
    connectorTypeId: 1,
    connectorsOrientationId: 3,
    reInforcementId: 1,
    slabTypeId: 1,
    slabTypeIdAuNz: 6,
    profiledSheetingOrientation: 1,
    profileSheetingTypeId: 1,
    shearConnectorTypeId: 1,
    degreeOfShearConnectionId: 2,
    shearConnectorOrientationId: 2,
    sheetingOrientationId: 1
  };

  private calculationMessagesValuesRanges: models.ErrorCodesTranslationValidationRanges;

  constructor(
    private configService: ConfigService,
    private sharedService: SharedService,
    private subProjectService: SubProjectService,
    private projectService: ProjectService,
    private sessionStorageService: SessionStorageService,
    private fb: FormBuilder, private router: Router,
    private calculationsService: CalculationsService,
    private route: ActivatedRoute,
    private user: UserService,
    public translate: TranslateService,
    private navService: NavService,
    private applicationOptionsService: ApplicationOptionsService) {
    this.initializeSubProjectForm();
    this.drawCompositeSubject = new Subject();
    this.drawCompositeSubject.pipe(debounceTime(1000)).subscribe({
      next: this.debouncedCompositeDrawings,
      error: null,
      complete: null
    });
    this.isFormValidSubject = new Subject();
    this.isFormValidSubject.pipe(debounceTime(600)).subscribe({ next: this.debouncedIsFormValid, error: null, complete: null });
    this.dropDownOptions = this.applicationOptionsService.options;
    this.setDropDowns(this.dropDownOptions);
    const version = this.configService.config.applicationVersion.split('.');
    this.appVersion = {
      first: Number(version[0]),
      second: Number(version[1]),
      third: Number(version[2]),
      beta: this.configService.config.beta ? 1 : 0
    };
  }

  ngOnInit(): void {

    if (!this.user.defaultSettings) {
      this.router.navigate(['/settings']);
    }

    this.route.params.subscribe(params => {
      this.handleParams(params);
    });

    this.projectService.getsubProjects(this.projectId).subscribe((data) => {
      this.subProjects = _.isArray(data.subProjects) ? data.subProjects : [];
    });

    this.sharedService.changeBreadCrumb('subproject');
    this.init();
  }

  init = (): any => {
    this.sharedService.showLoader(true);
    const combine = observableZip(
      this.subProjectService.getSubProjectById(this.subProjectId),
      this.projectService.getProjectById(this.projectId));
    combine.subscribe(([subProject, project]) => {
      if (subProject) {
        this.project = project;
        this.project.unit = this.project.unit ? this.project.unit : SubProjectComponent.DEFAULT_UNIT_SYSTEM;

        // SubProject.steelProfile.profileName == null is HACK to check if subroject was correctly created
        this.subProjectModel = this.isNew || subProject.steelProfile.profileName == null ? this.initializeDefaultSubProject(subProject, project) : subProject;

        this.subProjectModel.projectName = project.name;
        if (!this.subProjectModel.profileSheeting.profileName) {
          Object.assign(this.subProjectModel.profileSheeting, this.getDefaultCustomProfileSheeting(project.unit));
        }
        if (!this.subProjectModel.steelProfile.yieldStrength) {
          this.subProjectModel.steelProfile.yieldStrength = this.getDefaultSteelProfileYieldStrength(project.unit);
        }

        if (!this.subProjectModel.deformation.walkingActivity) {
          this.subProjectModel.deformation.walkingActivity = SubProjectComponent.DEFAULT_WALKING_ACTIVITY;
        }

        if (!this.subProjectModel.deformation.rhythmicActivity) {
          this.subProjectModel.deformation.rhythmicActivity = SubProjectComponent.DEFAULT_RHYTMIC_ACTIVITY;
        }

        if (!this.subProjectModel.deformation.dampling) {
          this.subProjectModel.deformation.dampling = 1;
        }
        if (this.subProjectModel.deformation.compositeDeflectionLimit < 8 && this.project.designCode === 2) {
          this.subProjectModel.deformation.compositeDeflectionLimit = SubProjectComponent.DEFAULT_LIVE_LOAD_DEFL_ID_AMERICAN;
        }
        if (this.subProjectModel.deformation.totalDeflectionLimit < 8 && this.project.designCode === 2) {
          this.subProjectModel.deformation.totalDeflectionLimit = SubProjectComponent.DEFAULT_DEFLECTION_LIMIT_ID_AMERICAN;
        }

        if (this.subProjectModel.deformation.constructionTypeId <= 2 && this.project.designCode === 2) {
          this.subProjectModel.deformation.constructionTypeId = 3;
        }

        if (this.project.designCode === 2 && this.subProjectModel.beamGeometry.slabTypeId === 1) {
          this.subProjectModel.beamGeometry.slabTypeId = 3;
        }
        if (this.project.designCode === 2 && this.subProjectModel.beamGeometry.slabTypeId === 2) {
          this.subProjectModel.beamGeometry.slabTypeId = 4;
        }

        if (this.project.designCode === 3 && this.subProjectModel.beamGeometry.slabTypeId === 1) {
          this.subProjectModel.beamGeometry.slabTypeId = 5;
        }
        if (this.project.designCode === 3 && this.subProjectModel.beamGeometry.slabTypeId === 2) {
          this.subProjectModel.beamGeometry.slabTypeId = 6;
        }

        if (this.project.designCode === 2 && this.project.unit === 2 && this.subProjectModel.steelProfile.yieldStrength >= 50) {
          // convert psi => ksi for existing projects
          this.subProjectModel.steelProfile.yieldStrength = this.subProjectModel.steelProfile.yieldStrength / 1000;
        }
        if (this.project.designCode === 2 && this.project.unit === 2 && this.subProjectModel.profileSheeting.yieldStrength >= 85) {
          this.subProjectModel.profileSheeting.yieldStrength = this.subProjectModel.profileSheeting.yieldStrength / 1000;
        }
        if (this.subProjectModel.shearConnector.userConnectionDegree < 10) {
          this.subProjectModel.shearConnector.userConnectionDegree = 10;
        }

        if (this.project.designCode === 3) {
          if (this.subProjectModel.steelProfile.steelStandardNZS === 0) {
            this.subProjectModel.steelProfile.steelStandardNZS = this.project.countryNationalAnnexes === 38 ? 1 : 2;
          }
        }

        if (this.project.designCode === 3 && this.subProjectModel.steelProfile.steelGradeId === 9) {
          this.subProjectModel.steelProfile.steelGradeId = 13;
        }
        if (this.subProjectModel.concreteSlab.concreteClassId === 0) {
          this.subProjectModel.concreteSlab.concreteClassId = 1;
        }
        if (this.subProjectModel.beamGeometry.beamLocationId === 0) {
          this.subProjectModel.beamGeometry.beamLocationId = 1;
        }
        if (this.subProjectModel.beamGeometry.slabTypeId === 0) {
          this.subProjectModel.beamGeometry.slabTypeId = 1;
        }

        if (this.subProjectModel.load.loadCases.length === 0) {
          this.subProjectModel.load.loadCases = this.getDefaultLoadCases();
        }

        const minConcreteStrenghUS = this.project.unit === 1 ? SubProjectComponent.CONCRETE_STRENGTH_US_METRIC : SubProjectComponent.CONCRETE_STRENGTH_US_IMPERIAL;
        if (this.subProjectModel.concreteSlab.concreteStrengthUS < minConcreteStrenghUS) {
          this.subProjectModel.concreteSlab.concreteStrengthUS = minConcreteStrenghUS;
        }

        this.partialFactor = this.getPartialFactorFromProject(project);
        this.forceFactor = UnitHelper.getDbToDisplayForceFactor(project.loadUnit);
        this.unitSystem = UnitHelper.getUnitSystem(project.unit, project.loadUnit, project.lengthUnit);
        this.initializeLoadCasesInDisplayUnits();
        this.setValidators(project.unit);
        this.populateSubProjectForm();
        this.updateNav();
        if (this.isNew) {
          this.saveSubProject(false);
        }
        this.activateValueChanges();
      }
    },
      (error: any) => console.log(error),
      () => this.sharedService.showLoader(false));
  }

  private initializeDefaultSubProject = (subProject: models.SubProject, project: models.Project): models.SubProject => {
    subProject.beamGeometry.beamLength = project.unit === 1 ? 2 : 20;
    subProject.beamGeometry.beamLocationId = this.DEFAULT_DROPDOWNS.beamLocationId;
    // tslint:disable-next-line:max-line-length
    subProject.beamGeometry.beamLocationValue = this.dropDownOptions.beamLocations.find(bl => bl.id === this.DEFAULT_DROPDOWNS.beamLocationId).value;
    subProject.beamGeometry.beamTypeId = 2;
    subProject.beamGeometry.beamTypeValue = 1;
    subProject.beamGeometry.leftOpening = false;
    subProject.beamGeometry.leftOpeningPosition = project.unit === 1 ? 0.25 : 1;
    subProject.beamGeometry.leftSpacing = project.unit === 1 ? 0.5 : 2;
    subProject.beamGeometry.rightOpening = false;
    subProject.beamGeometry.rightOpeningPosition = project.unit === 1 ? 0.25 : 1;
    subProject.beamGeometry.rightSpacing = project.unit === 1 ? 0.5 : 2;
    subProject.beamGeometry.slabTypeId = this.DEFAULT_DROPDOWNS.slabTypeId;
    subProject.beamGeometry.slabTypeValue = this.dropDownOptions.slabTypes.find(sl => sl.id === this.DEFAULT_DROPDOWNS.slabTypeId).value;

    subProject.combinationFactor = this.user.defaultSettings.combinationFactor;

    subProject.concreteSlab.concreteClassId = SubProjectComponent.DEFAULT_CONCRETE_CLASS_ID;
    // tslint:disable-next-line:max-line-length
    subProject.concreteSlab.concreteClassValue = this.dropDownOptions.concreteClasses.find(cc => cc.id === SubProjectComponent.DEFAULT_CONCRETE_CLASS_ID).value;
    subProject.concreteSlab.concreteDensity = project.unit === 1 ? SubProjectComponent.CONCRETE_DENSITY_METRIC.max : SubProjectComponent.CONCRETE_DENSITY_IMPERIAL.max;
    subProject.concreteSlab.aggregatesDensity = project.unit === 1 ? SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_METRIC.max : SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_IMPERIAL.max;
    subProject.concreteSlab.concreteTypeId = this.DEFAULT_DROPDOWNS.concreteTypeId;
    // tslint:disable-next-line:max-line-length
    subProject.concreteSlab.concreteTypeValue = this.dropDownOptions.concreteTypes.find(ct => ct.id === this.DEFAULT_DROPDOWNS.concreteTypeId).value;
    subProject.concreteSlab.coverRequired = this.project.designCode === 1 ? false : true;
    subProject.concreteSlab.haunchHeight = 0;
    subProject.concreteSlab.concreteStrengthUS = project.unit === 1 ? SubProjectComponent.CONCRETE_STRENGTH_US_METRIC : SubProjectComponent.CONCRETE_STRENGTH_US_IMPERIAL;
    subProject.concreteSlab.slabThickness = project.unit === 1 ? 200 : 8;

    subProject.deformation.frequencyLimit = 3;
    subProject.deformation.percentageLiveLoad = 3;
    subProject.deformation.precamber = 0;
    subProject.deformation.incrementalDeflectionCheck = 0;
    subProject.deformation.permanentLoadFraction = 0.0;
    subProject.loadCategory = this.user.defaultSettings.loadCategory;
    subProject.liveLoadReduction = this.user.defaultSettings.liveLoadReduction;
    subProject.shearConnector.connectionDegreeId = this.DEFAULT_DROPDOWNS.degreeOfShearConnectionId;
    subProject.shearConnector.connectorTypeId = this.DEFAULT_DROPDOWNS.connectorTypeId;
    subProject.shearConnector.connectorsOrientationId = this.DEFAULT_DROPDOWNS.connectorsOrientationId;
    subProject.shearConnector.optimizationOption = 1;
    subProject.shearConnector.userConnectionDegree = 10;

    subProject.steelProfile.customProfile = false;
    subProject.steelProfile.elasticImposed = false;
    subProject.steelProfile.flangeThickness = project.unit === 1 ? 5 : 0.25;
    subProject.steelProfile.flangeWidth = project.unit === 1 ? 100 : 4;
    subProject.steelProfile.height = project.unit === 1 ? 100 : 4;
    if (project.designCode === 1 && this.project.unit === AppConstants.UNIT_SYSTEM_MI) {
      subProject.steelProfile.profileName = 'IPE 100';
    } else if (project.designCode === 3) {
      subProject.steelProfile.profileName = '310UBP149';
    } else {
      subProject.steelProfile.profileName = 'W44X335';
    }
    subProject.steelProfile.radius = 0;
    subProject.steelProfile.rootRadius = project.unit === 1 ? 3 : 0.08;
    switch (project.designCode) {
      case 1:
        subProject.steelProfile.steelGradeId = SubProjectComponent.DEFAULT_STEELGRADE_ID_EURO;
        subProject.reinforcement.steelGradeId = SubProjectComponent.DEFAULT_REINFORCEMENT_ID_EURO;
        subProject.deformation.constructionTypeId = SubProjectComponent.DEFAULT_CONSTRUCTIONTYPE_ID_EURO;
        subProject.deformation.totalDeflectionLimit = SubProjectComponent.DEFAULT_LIVE_LOAD_DEFL_ID_EURO;
        subProject.deformation.compositeDeflectionLimit = SubProjectComponent.DEFAULT_LIVE_LOAD_DEFL_ID_EURO;
        break;
      case 2:
        subProject.steelProfile.steelGradeId = SubProjectComponent.DEFAULT_STEELGRADE_ID_US;
        subProject.reinforcement.steelGradeId = SubProjectComponent.DEFAULT_REINFORCEMENT_ID_US;
        subProject.deformation.constructionTypeId = SubProjectComponent.DEFAULT_CONSTRUCTIONTYPE_ID_US;
        subProject.deformation.totalDeflectionLimit = SubProjectComponent.DEFAULT_DEFLECTION_LIMIT_ID_AMERICAN;
        subProject.deformation.compositeDeflectionLimit = SubProjectComponent.DEFAULT_LIVE_LOAD_DEFL_ID_AMERICAN;
        subProject.deformation.dampling = SubProjectComponent.DEFAULT_DAMPLING_ID_US;
        if (SubProjectComponent.META_COUNTRIES.find(x => x === project.countryNationalAnnexes)) {
          subProject.steelProfile.profileName = 'IPE 100';
          subProject.steelProfile.steelGradeId = SubProjectComponent.DEFAULT_STEELGRAGE_META_ID;
          subProject.shearConnector.userConnectionDegree = 25;
        }
        break;
      case 3:
        if (this.project.countryNationalAnnexes === 38) {
          subProject.steelProfile.steelGradeId = SubProjectComponent.DEFAULT_STEELGRADE_ID_AU;
          subProject.shearConnector.connectorsOrientationId = 2;
        } else {
          subProject.steelProfile.steelGradeId = SubProjectComponent.DEFAULT_STEELGRADE_ID_NZ;
          subProject.shearConnector.connectorsOrientationId = 1;
        }
        Object.assign(subProject.profileSheeting, this.getDefaultCustomProfileSheeting(project.unit));
        subProject.reinforcement.steelGradeId = SubProjectComponent.DEFAULT_REINFORCEMENT_ID_AUNZ;
        subProject.deformation.constructionTypeId = SubProjectComponent.DEFAULT_CONSTRUCTIONTYPE_AUNZ;
        subProject.deformation.totalDeflectionLimit = SubProjectComponent.DEFAULT_DEFLECTION_LIMIT_ID_AUNZ;
        subProject.deformation.compositeDeflectionLimit = SubProjectComponent.DEFAULT_LIVE_LOAD_DEFL_ID_AUNZ;
        subProject.beamGeometry.slabTypeId = this.DEFAULT_DROPDOWNS.slabTypeIdAuNz;
        subProject.shearConnector.connectorTypeId = 4;
        subProject.shearConnector.connectorTypeValue = 2;
        subProject.concreteSlab.slabThickness = project.unit === 1 ? 125 : 5;
        subProject.shearConnector.connectorsOrientationValue = 0;
        subProject.deformation.dampling = SubProjectComponent.DEFAULT_DAMPLING_ID_ASNZS;
        subProject.profileSheeting.profileName = SubProjectComponent.DEFAULT_PROFILE_ASNSZ;
        subProject.profileSheeting.sheetingOrientationId = 1;
        break;
    }
    // tslint:disable-next-line:max-line-length
    subProject.steelProfile.steelGradeValue = this.dropDownOptions.steelGrades.find(st => st.id === subProject.steelProfile.steelGradeId).value;
    subProject.steelProfile.webThickness = project.unit === 1 ? 4 : 0.125;

    subProject.deformation.walkingExcitationCheck = 1;
    subProject.deformation.rhythmicExcitationCheck = 0;
    subProject.deformation.walkingActivity = this.walkingActivity.find(x => x.id === 1).id;
    subProject.deformation.rhythmicActivity = this.rhythmicActivity.find(x => x.id === 1).id;
    subProject.load.loadCases = this.getDefaultLoadCases();
    if (this.project.countryNationalAnnexes === 38) {
      subProject.steelProfile.steelStandardNZS = 1;
    }
    if (this.project.countryNationalAnnexes === 39) {
      subProject.steelProfile.steelStandardNZS = 2;
    }
    subProject.deformation.performLateralTorsionBucklingCheck =
      this.getDefaultLateralTorsionBucklingCheckValue(project.countryNationalAnnexes);
    return subProject;
  }

  getDefaultLoadCases() {
    const loadCases = [];
    for (let i = 0; i < 4; i++) {
      loadCases[i] = {
        id: 0,
        distributedSurfaceLoad: 0,
        pointLoads: [], lineLoads: [],
        combinationFactor: this.user.defaultSettings.combinationFactor,
        sequence: i
      };
    }
    return loadCases;
  }

  private getDefaultLateralTorsionBucklingCheckValue(nationalAnnex: number) {
    if (SubProjectComponent.META_COUNTRIES.find(x => x === nationalAnnex)) {
      return 0;
    }
    return 1;
  }

  getDefaultCustomProfileSheeting = (unit: number): models.ProfileSheeting => {
    return <models.ProfileSheeting>{
      continuousForPerpendicular: true,
      numberRibStiffeners: 0,
      pitch: unit === 1 ? 100 : 4,
      profileName: 'Custom',
      ribBottomWidth: unit === 1 ? 30 : 1.25,
      ribHeight: unit === 1 ? 30 : 1.25,
      ribStiffenerWidth: 0,
      ribTopWidth: unit === 1 ? 30 : 1.25,
      sheetingOrientationId: this.DEFAULT_DROPDOWNS.sheetingOrientationId,
      sheetingOrientationValue: this.dropDownOptions.sheetingOrientations.find(so => so.id === this.DEFAULT_DROPDOWNS.sheetingOrientationId).value,
      stiffenersSpacing: 0,
      surfaceWeight: unit === 1 ? 20 : 4,
      thickness: unit === 1 ? 1 : 0.05,
      yieldStrength: unit === 1 ? 170 : 25
    };
  }

  getDefaultSteelProfileYieldStrength = (unit: number): number => {
    return unit === 1 ? 170 : 25;
  }

  handleParams = (params: Params): void => {
    if (params['projectid']) {
      this.projectId = +params['projectid']; // (+) converts string 'projectid' to a number
    }
    if (params['id']) {
      this.subProjectId = +params['id']; // (+) converts string 'id' to a number
    }
    if (params['isNew']) {
      this.isNew = params['isNew'] === 'true';
    }

    if (!this.subProjectId || !this.projectId) {
      this.router.navigate(['/project']);
    }
  }

  private updateNav() {
    try {
      this.navService.setNav([<INavItem>{
        routeName: 'Home',
        routeUrl: '/projects'
      }, <INavItem>{
        routeName: this.project.name,
        routeUrl: `/project;id=${this.projectId}`
      }, <INavItem>{
        routeName: this.subProjectForm['controls'].subprojectName.value,
        routeUrl: undefined
      }
      ]);
    } catch (err) {

    }
  }

  getUnitSystemValue = (unit: number): number => {
    const unitSystem = this.dropDownOptions.unitSystems.find(u => u.id === unit);
    return unitSystem ? unitSystem.value : 0;
  }

  getStandardValue = (designCode: number): number => {
    const standard = this.dropDownOptions.designCodes.find(u => u.id === designCode);
    return standard ? standard.value : 0;
  }

  populateLoadCategory = (data): void => {
    const settings = this.user.defaultSettings;
    const defaultLoadCateogry = settings && settings.loadCategory > 0 ? settings.loadCategory : SubProjectComponent.DEFAULT_LOAD;
    const loadCategory = this.subProjectModel.loadCategory ?
      (this.subProjectModel.loadCategory > 0 ? this.subProjectModel.loadCategory : defaultLoadCateogry) : defaultLoadCateogry;
    const defaultCombinationFactor = this.combinationFactors.filter(item => item.nationalAnnexId === data.countryNationalAnnexes && item.loadCategoryId === loadCategory)[0].value;
    const combinationFactor = this.subProjectModel.id === undefined || this.subProjectModel.id === 0 ?
      (settings && settings.combinationFactor ? settings.combinationFactor : defaultCombinationFactor) :
      ((this.subProjectModel.loadCategory && this.subProjectModel.loadCategory > 0) ?
        this.subProjectModel.combinationFactor : defaultCombinationFactor);
    this.subProjectModel.loadCategory = loadCategory;
    this.subProjectModel.combinationFactor = combinationFactor;
  }

  initializeLoadCasesInDisplayUnits = () => {
    for (const loadcase of this.subProjectModel.load.loadCases) {
      for (const pointLoad of loadcase.pointLoads) {
        pointLoad.location = pointLoad.location;
        pointLoad.value = pointLoad.value * this.forceFactor;
      }
      for (const lineload of loadcase.lineLoads) {
        lineload.originLoad.location = lineload.originLoad.location;
        lineload.originLoad.value = lineload.originLoad.value * this.forceFactor;
        lineload.endLoad.location = lineload.endLoad.location;
        lineload.endLoad.value = lineload.endLoad.value * this.forceFactor;
      }
      loadcase.distributedSurfaceLoad = loadcase.distributedSurfaceLoad * this.forceFactor;
    }
    this.subProjectModel.load.userCompositeSelfWeight =
      this.subProjectModel.load.userCompositeSelfWeight * this.forceFactor;
  }

  ngAfterViewInit() {
    const controlChanges: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => observableFromEvent(formControl.nativeElement, 'change'));
    observableMerge(this.subProjectForm.valueChanges, ...controlChanges).pipe(debounceTime(800)).subscribe(value => {
      for (const controlIndex in this.subProjectForm.controls) {
        if (this.subProjectForm.controls[controlIndex] != null) {
          this.subProjectForm.controls[controlIndex].markAsTouched();
        }
      }
    });
  }

  ngOnDestroy() {
    this.navService.setNav(null);
  }

  public saveOnLeave(doSave = true, doLeave = true) {
    if (doSave) {
      this.saveSubProject(doLeave);
    } else {
      this.showSaveOnDestroyDialog = false;
      this._saveOnLeaveSubject.next(doLeave);
    }
  }

  setDropDowns = (options: models.Options) => {
    this.beamLocations = _.sortBy(options.beamLocations, [function (o) { return o.label; }]);
    this.beamDesigns = _.sortBy(options.beamDesigns, [function (o) { return o.label; }]);
    this.beamTypes = _.sortBy(options.beamTypes, [function (o) { return o.label; }]);
    this.slabTypes = _.sortBy(options.slabTypes, [function (o) { return o.label; }]);
    this.profileTypes = _.sortBy(options.steelProfileRanges,
      [function (o) { return o.profileRange === 'Custom' ? 'ZZZ' : o.profileRange; }]);
    this.steelprofiles = _.sortBy(options.steelProfiles, [function (o) { return o.label === 'Custom' ? 'ZZZ' : o.label; }]);
    this.steelGrades = _.sortBy(options.steelGrades, [function (o) { return o.label === 'Custom' ? 'ZZZ' : o.label; }]);
    this.concreteTypes = _.sortBy(options.concreteTypes, [function (o) { return o.label === 'Custom' ? 'ZZZ' : o.label; }]);
    this.concreteClasses = _.sortBy(options.concreteClasses, [function (o) { return o.label === 'Custom' ? 'ZZZ' : o.label; }]);
    this.concreteStrengths = _.sortBy(options.concreteStrengths, [function (o) { return o.label; }]);
    this.reinforcementSteelGrades = _.sortBy(options.reinforcementSteelGrades, [function (o) { return o.label; }]);
    this.sheetingOrientations = _.sortBy(options.sheetingOrientations, [function (o) { return o.label; }]);
    this.shearConnectionDegrees = _.sortBy(options.shearConnectionDegrees, [function (o) { return o.label; }]);
    this.shearConnectorOrientations = _.sortBy(options.shearConnectorOrientations, [function (o) { return o.label; }]);
    this.filteredConnectorOrientations = this.shearConnectorOrientations;
    this.shearConnectorTypes = _.sortBy(options.shearConnectorTypes, [function (o) { return o.id; }]);
    this.filteredConnectorTypes = this.shearConnectorTypes;
    this.deflectionLimits = _.sortBy(options.deflectionLimits, [function (o) { return o.label; }]);
    this.liveLoadPercentages = _.sortBy(options.liveLoadPercents, [function (o) { return o.label; }]);
    this.totalLoadDeflections = _.sortBy(options.deflectionLimits, [function (o) { return o.label; }]);
    // @ts-ignore
    this.constructionTypes = _.sortBy(options.constructionTypes, [function (o) { return o.label; }]);
    this.loadCategories = _.sortBy(options.loadCategories, [function (o) { return o.id; }]);
    this.nationalAnnexes = _.sortBy(options.nationalAnnexes, [function (o) { return o.label; }]);
    this.combinationFactors = options.combinationFactors;
    this.partialFactors = options.partialFactors;
    this.walkingActivity = options.walkingActivities;
    this.rhythmicActivity = options.rytmicExitations;
    this.damplings = options.damplings;
  }

  public getCurrentProfileSheetings(options, countryNationalAnnexes) {
    const currentNationalProfileSheetings = options.nationalProfileSheetings.filter(function (np) { return np.nationalAnnexId === countryNationalAnnexes; });
    const currentProfileSheetings = currentNationalProfileSheetings.map(function (ps) { return options.profileSheetings.find(op => op.id === ps.profileSheetingId); });
    return _.sortBy(currentProfileSheetings, [function (o) { return o.label === 'Custom' ? 'ZZZ' : o.label; }]);
  }

  setBeamLabels = (key: string): void => {
    if (key === 'edge-beam') {
      this.beamLocationB1Text = 'edge-spacing-b1';
      this.beamLocationB2Text = 'adjacent-beam-spacing-b2';
      this.beamLocationB1Error = 'edge-beam-spacing-range';
      this.beamLocationB2Error = 'adjacent-beam-spacing-range';
    } else {
      this.beamLocationB1Text = 'beam-spacing-left';
      this.beamLocationB2Text = 'beam-spacing-right';
      this.beamLocationB1Error = 'left-beam-spacing-range';
      this.beamLocationB2Error = 'right-beam-spacing-range';
    }
  }

  setCombinationFactorAndPartialFactors = (loadCategory): void => {
    const nationalAnnex = this.project.countryNationalAnnexes;

    if (this.project.designCode === 1) {
      const combinationFactor = this.combinationFactors.
        filter(item => item.nationalAnnexId === nationalAnnex && item.loadCategoryId === loadCategory.id)[0];
      this.subProjectForm.get('combinationFactor').setValue(combinationFactor.value);
    }
    if (this.project.designCode === 2) {
      this.subProjectForm.get('liveLoadReduction').setValue('false');
    }
  }

  calcuateLWCDensity(value) {
    if (this.project.designCode === 1) {
      this.calculationsService.getLWCDensity(+value).subscribe(result => {
        this.subProjectForm.get('concreteDensity').setValue(result.density);
      })
    }
    else {
      this.subProjectForm.get('concreteDensity').setValue(value);
    }
  }

  activateValueChanges() {
    this.subProjectForm.get('subprojectName').valueChanges.pipe(debounceTime(200)).subscribe(data => {
      this.updateNav();
    });

    this.subProjectForm.get('aggregatesDensity').valueChanges.pipe(debounceTime(200)).subscribe(data => {
      this.calcuateLWCDensity(data);
    });

    this.subProjectForm.get('loadCategory').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onLoadCategoryChange(data);
    });

    // Beam Geometry
    this.subProjectForm.get('beamLocation').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.subProjectForm.get('beamSpacingLeft').updateValueAndValidity();
      this.onBeamLocationChange(data);
    });
    this.subProjectForm.get('beamLength').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onBeamLengthChange(data);
    });
    this.subProjectForm.get('beamSpacingRight').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.subProjectForm.get('rightOpeningPosition').updateValueAndValidity();
      this.onBeamSpacingRightChange(data);
    });
    this.subProjectForm.get('beamSpacingLeft').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.subProjectForm.get('leftOpeningPosition').updateValueAndValidity();
      this.onBeamSpacingLeftChange(data);
    });
    this.subProjectForm.get('leftOpening').valueChanges.subscribe(data => {
      this.onLeftOpeningChange(data);
      this.validateAndDrawBeamGeometry();
    });
    this.subProjectForm.get('leftOpeningPosition').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawBeamGeometry();
    });
    this.subProjectForm.get('rightOpening').valueChanges.subscribe(data => {
      this.onRightOpeningChange(data);
      this.validateAndDrawBeamGeometry();
    });
    this.subProjectForm.get('rightOpeningPosition').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawBeamGeometry();
    });
    // Materials

    this.subProjectForm.get('profileType').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onProfileTypeChange(data);
    });

    this.subProjectForm.get('steelProfile').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onSteelProfileChange(data);
    });

    this.subProjectForm.get('steelGrade').valueChanges.pipe(debounceTime(500)).subscribe(steelGrade => {
      this.validateAndDrawSteelProfile();
    });

    this.subProjectForm.get('elasticImposed').valueChanges.pipe(debounceTime(500)).subscribe(() => {
      this.onElasticImposedChange();
    });

    this.subProjectForm.get('steelProfileCustomSteelGradeYieldStrength').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawSteelProfile();
    });

    this.subProjectForm.get('steelProfileCustomHeight').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawSteelProfile();
    });

    this.subProjectForm.get('steelProfileCustomFlangeWidth').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawSteelProfile();
    });

    this.subProjectForm.get('steelProfileCustomWebThickness').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawSteelProfile();
    });

    this.subProjectForm.get('profileSheetingCustomThicknessGage').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onGageThicknessChange(data);
    });

    this.subProjectForm.get('steelProfileCustomFlangeThickness').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawSteelProfile();
    });

    this.subProjectForm.get('steelProfileCustomRootRadius').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.validateAndDrawSteelProfile();
    });

    this.subProjectForm.get('concreteType').valueChanges.pipe(debounceTime(500)).subscribe(concreteType => {
      this.onConcreteTypeChange(concreteType);
    });

    this.subProjectForm.get('profiledSheetingType').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onProfiledSheetingTypeChange(data);
    });

    this.subProjectForm.get('profiledSheetingCustomThickness').valueChanges.pipe(debounceTime(1000)).subscribe(data => {
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomDeckDepth').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomTroughSpacing').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomBottomWidth').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.subProjectForm.get('profiledSheetingCustomTroughSpacing').updateValueAndValidity();
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomTopWidth').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.subProjectForm.get('profiledSheetingCustomTroughSpacing').updateValueAndValidity();
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomNumberRibStiffeners').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onProfiledSheetingCustomNumberRibStiffenersChange(data);
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomRibStiffenerWidth').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.subProjectForm.get('profiledSheetingCustomBottomWidth').updateValueAndValidity();
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomStiffenersSpacing').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.subProjectForm.get('profiledSheetingCustomBottomWidth').updateValueAndValidity();
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomSurfaceWeight').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingCustomYieldStrength').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.getSlabDrawing();
    });

    this.subProjectForm.get('profiledSheetingOrientation').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onProfiledSheetingOrientationChange(data);
    });

    this.subProjectForm.get('slabType').valueChanges.subscribe(slabType => {
      this.onSlabTypeChange(slabType);
    });

    this.subProjectForm.get('slabThickness').valueChanges.pipe(debounceTime(500)).subscribe(slabThickness => {
      this.onSlabThicknessChange(slabThickness);
    });

    this.subProjectForm.get('haunchHeight').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onHaunchHeightChange(data);
    });

    this.subProjectForm.get('liveLoadInConstruction').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onLiveLoadInConstructionChanges(data);
    });

    this.subProjectForm.get('permanentLoad').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onPermanentLoadChanges(data);
    });


    this.subProjectForm.get('userSelfWeight').valueChanges.pipe(debounceTime(1000)).subscribe(userWeight => {
      this.onUserSelfWeightChanges(userWeight);
    });

    this.subProjectForm.get('liveLoad').valueChanges.pipe(debounceTime(1000)).subscribe(userLiveLoad => {
      this.onLiveLoadChanges(userLiveLoad);
    });

    this.subProjectForm.get('shearConnectionType').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onShearConnectorTypeChanges(data);
    });

    this.subProjectForm.get('shearConnectionDegree').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onShearConnectionDegreeChanges(data);
    });


    this.subProjectForm.get('shearConnectionOrientation').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onShearConnectionOrientationChanges(data);
    });

    this.subProjectForm.get('coverRequired').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onConverRequiredChanges(data);
    });

    this.subProjectForm.get('overrideSelfWeight').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onOverrideSelfWeightChanged(data);
    });

    this.subProjectForm.get('overrideLiveLoad').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onOverrideLiveLoadChanged(data);
    });
    this.subProjectForm.get('walkingActivity').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onWalkingActivityChange(data);
    });
    this.subProjectForm.get('rhythmicExcitationCheck').valueChanges.subscribe(data => {
      this.onRytmicExcitationCheckchange(data);
    });

    this.subProjectForm.get('steelStandardNZS').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onSteelStandardChange(data);
    });

    this.subProjectForm.get('walkingExcitation').valueChanges.pipe(debounceTime(500)).subscribe(data => {
      this.onWalkingExcitationChange(data);
    });
  }

  public onWalkingExcitationChange(data: boolean) {
    if (data) {
      this.subProjectForm.get('walkingActivity').enable();
    } else {
      this.subProjectForm.get('walkingActivity').disable();
    }
  }

  public onRytmicExcitationCheckchange(data) {
    if (!data) {
      this.subProjectForm.get('rhythmicActivity').disable();
    } else {
      this.subProjectForm.get('rhythmicActivity').enable();
    }
  }

  public onWalkingActivityChange(data) {
    if (data.value === 1) {
      this.subProjectForm.get('dampling').setValue(this.damplings.find(x => x.value === 0.02));
      if (this.project.designCode === 2) {
        this.subProjectForm.get('dampling').disable({ emitEvent: false });
        this.displayWalkingExitationNote = true;
      }
    } else {
      this.subProjectForm.get('dampling').enable({ emitEvent: false });
      this.displayWalkingExitationNote = false;
    }
  }

  onLoadCategoryChange = (loadCategory) => {
    this.setCombinationFactorAndPartialFactors(loadCategory);
  }

  onBeamLocationChange = (beamLocation) => {
    this.setBeamLabels(beamLocation.labelKey);
    if (beamLocation.id === 2) {
      this.subProjectForm.get('leftOpening').setValue(false);
      this.subProjectForm.get('leftOpeningPosition').updateValueAndValidity();
    }
    this.setBeamSpacingValidators(beamLocation.id);
    this.validateAndDrawBeamGeometry();
  }

  setBeamSpacingValidators(beamLocationId: any) {
    if (this.project.unit === 1) {
      // tslint:disable-next-line:max-line-length
      this.validationValues.beamSpacingLeft.min = (beamLocationId === 2 ? SubProjectComponent.BEAM_SPACING_INTERMEDIATE_METRIC_MIN : SubProjectComponent.BEAM_SPACING_EDGE_METRIC_MIN);
      this.validationValues.beamSpacingLeft.max = SubProjectComponent.BEAM_LENGTH_METRIC.max;
      this.validationValues.beamSpacingRight.min = SubProjectComponent.BEAM_SPACING_EDGE_METRIC_MIN;
      this.validationValues.beamSpacingRight.max = SubProjectComponent.BEAM_LENGTH_METRIC.max;
    } else {
      // tslint:disable-next-line:max-line-length
      this.validationValues.beamSpacingLeft.min = (beamLocationId === 2 ? SubProjectComponent.BEAM_SPACING_INTERMEDIATE_IMPERIAL_MIN : SubProjectComponent.BEAM_SPACING_EDGE_IMPERIAL_MIN);
      this.validationValues.beamSpacingLeft.max = SubProjectComponent.BEAM_LENGTH_IMPERIAL.max;
      this.validationValues.beamSpacingRight.min = SubProjectComponent.BEAM_SPACING_EDGE_IMPERIAL_MIN;
      this.validationValues.beamSpacingRight.max = SubProjectComponent.BEAM_LENGTH_IMPERIAL.max;
    }
  }

  onProfileTypeChange = (profileType) => {
    if (!profileType) {
      return;
    }
    if (profileType.profileRange !== 'Custom') {
      if (this.project.designCode === 2) {
        this.steelProfilesPerRange = _
          .sortBy(
            this.steelprofiles.filter(p => p.steelProfileRange.id === profileType.id),
            o => o.id).reverse();
      } else {
        this.steelProfilesPerRange = this.steelprofiles.filter(p => p.steelProfileRange.id === profileType.id);
      }

      let profile = this.steelProfilesPerRange.find(x => x.label === this.subProjectModel.steelProfile.profileName);
      if (!profile) {
        profile = this.steelProfilesPerRange[0];
      }
      this.subProjectForm.get('steelProfile').setValue(profile);
    } else {
      const profile = { label: 'Custom' };
      this.subProjectForm.get('steelProfile').setValue(profile);
    }
    this.setCustomSteelProfileValidators();
    this.validateAndDrawSteelProfile();
  }

  onBeamLengthChange = (length) => {
    this.validateAndDrawBeamGeometry();
  }

  onBeamSpacingLeftChange = (spacing) => {
    this.validateAndDrawBeamGeometry();
  }

  onBeamSpacingRightChange = (spacing) => {
    this.validateAndDrawBeamGeometry();
  }

  onLeftOpeningChange = (data) => {
    const control = this.subProjectForm.get('leftOpeningPosition');
    if (data) {
      control.setValue(this.subProjectForm.value.beamSpacingLeft / 2);
    }
    control.updateValueAndValidity();
  }

  onRightOpeningChange = (data) => {
    const control = this.subProjectForm.get('rightOpeningPosition');
    if (data) {
      control.setValue(this.subProjectForm.value.beamSpacingRight / 2);
    }
    control.updateValueAndValidity();
  }


  onSteelProfileChange = (steelProfile) => {
    this.selectedSteelProfile = steelProfile;
    this.subProjectForm.value.steelProfile.profileName = steelProfile.label;
    this.subProjectForm.value.steelProfile.label = steelProfile.label;
    this.subProjectForm.value.steelProfile.height = steelProfile.height;
    this.subProjectForm.value.steelProfile.flangeWidth = steelProfile.flangeWidth;
    this.subProjectForm.value.steelProfile.webThickness = steelProfile.webThickness;
    this.subProjectForm.value.steelProfile.rootRadius = steelProfile.rootRadius;
    this.subProjectForm.value.steelProfile.radius = steelProfile.radius;
    this.validateAndDrawSteelProfile();
  }

  onElasticImposedChange = () => {
    this.subProjectForm.get('shearConnectionDegree').setValue(_.first(this.shearConnectionDegrees));
  }

  onProfiledSheetingTypeChange = (profiledSheetingType) => {
    this.filteredConnectorOrientations = this.shearConnectorOrientationFiltered();
    const label = profiledSheetingType ? profiledSheetingType.label : '';
    if (label === 'Custom') {
      this.subProjectForm.value.profiledSheetingType = { label: 'Custom' };
    }
    this.getSlabDrawing();
  }

  onProfiledSheetingCustomNumberRibStiffenersChange = (number) => {
    if (number < 2) {
      this.subProjectForm.get('profiledSheetingCustomStiffenersSpacing').setValue(0);
    }
    if (number < 1) {
      this.subProjectForm.get('profiledSheetingCustomRibStiffenerWidth').setValue(0);
    }
  }

  validateAndSetShearConnectionOrientation() {
    const orientation = this.subProjectForm.get('shearConnectionOrientation').value;
    if (!this.filteredConnectorOrientations.find(i => i.id === orientation.id)) {
      this.subProjectForm.get('shearConnectionOrientation').setValue(_.last(this.filteredConnectorOrientations));
    } else {
      this.subProjectForm.get('shearConnectionOrientation').setValue(orientation);
    }
  }

  onProfiledSheetingOrientationChange = (profiledSheetingOrientation) => {
    this.filteredConnectorOrientations = this.shearConnectorOrientationFiltered();
    const orientation = this.subProjectForm.get('shearConnectionOrientation').value;
    this.validateAndSetShearConnectionOrientation();
    this.getSlabDrawing();
  }

  handleSlabThicknessChanges = (slabThickness: number) => {
    this.filteredConnectorTypes = this.shearConnectorTypesFiltered() || [];
    if (this.filteredConnectorTypes.length > 0) {
      this.subProjectForm.get('shearConnectionType').setValue(_.last(this.filteredConnectorTypes), {
        emitEvent: true,
        emitViewToModelChange: true
      });
      this.getSlabDrawing();
    }
  }

  onSlabThicknessChange = (slabThickness) => {
    this.filteredConnectorTypes = this.shearConnectorTypesFiltered();
    this.subProjectForm.get('shearConnectionType').setValue(_.last(this.filteredConnectorTypes));
    this.handleSlabThicknessChanges(slabThickness);
  }

  onHaunchHeightChange = (haunchHeight) => {
    this.filteredConnectorTypes = this.shearConnectorTypesFiltered();
    this.subProjectForm.get('shearConnectionType').setValue(_.last(this.filteredConnectorTypes));
    this.getSlabDrawing();
  }

  onConcreteTypeChange = (concreteType) => {
    this.concreteClassesPerConcreteType = this.getConcreteClasses(this.project.countryNationalAnnexes, concreteType.id);
    if (this.concreteClassesPerConcreteType && this.concreteClassesPerConcreteType.length > 0) {
      const concreteClass = this.concreteClassesPerConcreteType[0];
      this.subProjectForm.get('concreteClass').setValue(concreteClass);
    }
    if (concreteType.id === 2) {
      this.subProjectForm.get('concreteDensity').setValue(this.project.unit === 1 ? 1800 : 90);
      this.subProjectForm.get('aggregatesDensity').setValue(this.project.unit === 1 ? 1800 : 90);
      this.validateAndDrawSteelProfile();
    } else {
      this.subProjectForm.get('concreteDensity').setValue(this.project.unit === 1 ? 2500 : 155);
      this.validateAndDrawSteelProfile();
    }

    this.updateCustomDefinedConcreteRangeValidationRules(concreteType);

    if (this.subProjectForm.controls.concreteStrength.value.label === 'Custom') {
      this.subProjectForm.controls.concreteStrengthUS.updateValueAndValidity();
    }
  }

  onSlabTypeChange = (slabType: models.ConcreteSlab) => {
    this.filteredConnectorTypes = this.shearConnectorTypesFiltered();
    this.subProjectForm.get('shearConnectionType').setValue(_.last(this.filteredConnectorTypes),
      { emitEvent: true, emitViewToModelChange: true });

    if (slabType.id === 1 || slabType.id === 3) { // Solid Slab Id = 1
      this.setSolidSlab();
      // TODO: Solid Slab Drawing needs to be verified with Engineering team
      this.slabDrawing1 = '';
      this.slabDrawing2 = '';
    } else {
      this.setProfileSheeting(); // Set the default values for Profile Sheeting
    }
    this.subProjectForm.get('haunchHeight').setValue(0);
    this.getSlabDrawing();
  }

  onLiveLoadInConstructionChanges = (load: number) => {
    this.subProjectModel.load.loadCases[0].distributedSurfaceLoad = load;
    if (this.selectedTab === SubProjectComponent.LOADS) {
      this.getLoadDrawing(0);
    }
  }

  onPermanentLoadChanges = (load: number) => {
    this.subProjectModel.load.loadCases[1].distributedSurfaceLoad = load;
    if (this.selectedTab === SubProjectComponent.LOADS) {
      this.getLoadDrawing(1);
    }
  }


  onUserSelfWeightChanges = (userWeight: number) => {
    this.subProjectModel.load.userCompositeSelfWeight = userWeight;
    if (this.selectedTab === SubProjectComponent.LOADS) {
      this.getLoadDrawing(1);
    }
  }

  onLiveLoadChanges = (userLiveLoad: number) => {
    this.subProjectModel.load.loadCases[2].distributedSurfaceLoad = userLiveLoad;
    if (this.selectedTab === SubProjectComponent.LOADS) {
      this.getLoadDrawing(2);
    }
  }

  onShearConnectorTypeChanges = (shearConnectorType) => {
    this.filteredConnectorOrientations = this.shearConnectorOrientationFiltered();
    if (this.filteredConnectorOrientations.length > 0) {
      this.validateAndSetShearConnectionOrientation();
      if (this.filteredConnectorOrientations.length === 1) {
        this.subProjectForm.get('shearConnectionOrientation').disable();
      } else {
        this.subProjectForm.get('shearConnectionOrientation').enable();
      }
    }
    this.isFormValid();
    this.drawCompositeDrawings();
  }

  onShearConnectionDegreeChanges = (shearConnectionDegree) => {
    this.drawCompositeDrawings();
  }

  onShearConnectionOrientationChanges = (shearConnectionOrientation) => {
    this.drawCompositeDrawings();
  }

  displayInfoMessage = (coverRequired) => {
    if (coverRequired && coverRequired === true) {
      this.displayCoverRequiredYes = true;
      this.displayCoverRequiredNo = false;
    } else {
      this.displayCoverRequiredNo = true;
      this.displayCoverRequiredYes = false;
    }
  }

  onConverRequiredChanges = (coverRequired) => {
    this.displayInfoMessage(coverRequired);
    this.filteredConnectorTypes = this.shearConnectorTypesFiltered();
    this.filteredConnectorOrientations = this.shearConnectorOrientationFiltered();
    this.subProjectForm.get('shearConnectionType').setValue(_.last(this.filteredConnectorTypes),
      { emitEvent: true, emitViewToModelChange: true });
    this.drawCompositeDrawings();
  }

  onOverrideSelfWeightChanged = (event) => {
    this.overrideSelfWeight = event;
    if (!event) {
      this.subProjectModel.load.userCompositeSelfWeight = this.calculatedSelfWeightDisplay;
      this.subProjectForm.get('userSelfWeight').setValue(this.calculatedSelfWeightDisplay);
    }
  }

  onOverrideLiveLoadChanged = (event) => {
    this.overrideLiveLoad = event;
    if (!event) {
      this.subProjectForm.get('liveLoad').setValue(this.calculatedLiveLoadDisplay);
      this.subProjectModel.load.loadCases[2].distributedSurfaceLoad = this.calculatedLiveLoadDisplay;
    }
  }

  setSolidSlab = () => {
    this.profiledSheetingDrawing = '';
    this.subProjectModel.profileSheeting = { id: this.subProjectModel.profileSheeting && this.subProjectModel.profileSheeting.id || 0 };
  }

  setProfileSheeting = () => {
    this.subProjectForm.get('profiledSheetingType').setValue(this.profileSheetings[0]);
    this.subProjectForm.get('profiledSheetingOrientation').setValue(this.sheetingOrientations.filter(item =>
      item.id === SubProjectComponent.DEFAULT_ID)[0]);
  }

  validateAndDrawBeamGeometry = (): void => {
    if (this.isValidBeamGeometryDrawing()) {
      this.getBeamGeometryDrawing(300, SubProjectComponent.DRAWING_HEIGHT);
    }
  }

  validateAndDrawSteelProfile = (): void => {
    this.subProjectForm.get('steelProfileCustomHeight').updateValueAndValidity({ emitEvent: false });
    if (this.isValidSteelProfile()) {
      this.getSteelSectionDrawing(300, SubProjectComponent.DRAWING_HEIGHT);
    } else {
      this.steelSectionDrawingStream1 = '';
      this.steelSectionDrawingStream2 = '';
    }
  }

  validateAndDrawProfileSheeting = (): void => {
    if (this.subProjectForm.value.slabType.value === 1) {
      if (this.isValidSlabDrawing()) {
        this.getProfiledSheetingDrawing(300, SubProjectComponent.DRAWING_HEIGHT);
      } else {
        this.profiledSheetingDrawing = '';
      }
    }
  }

  private isCalculationError = (response: any): boolean => {
    this.calculateError = (!response || (response.errorCodes && response.errorCodes.length > 0));
    const pdfError = this.calculateError && response.errorCodes.length === 1 && response.errorCodes[0] === 998;
    const calculationErrors = this.calculateError && !pdfError;
    return calculationErrors;
  }

  private handleDesignResult = (response: any): void => {
    if (response.designCriteriaOk) {
    } else {
      if (!this.calculateError) {
      } else {
        this.sharedService.popFailure('error-on-calculate');
      }
    }
  }

  private isPdfError = (response: any): boolean => {
    this.calculateError = (!response || (response.errorCodes && response.errorCodes.length > 0));
    const pdfError = this.calculateError && response.errorCodes.length === 1 && response.errorCodes[0] === 998;
    return pdfError;
  }

  private updateCalculationConnectionZonesDrawings(response: models.Calculate.CalculationResult) {
    const connectionZones = this.getObservableConnectionZonesDrawing(
      response.shearConnectionResult,
      SubProjectComponent.DRAWING_WIDTH,
      SubProjectComponent.DRAWING_HEIGHT);
    const subscribe = connectionZones.subscribe(drawingStream => {
      let connectionZoneDrawing = '';
      if (drawingStream) {
        connectionZoneDrawing = `data:image/jpg;base64,${drawingStream}`;
      }
      this.calculateComponent.updateConnectionZones(connectionZoneDrawing);
    }, error => {
      console.log('Error getting the connection zones drawings');
      this.calculateComponent.updateConnectionZones('');
    });
  }

  private updateCalculationZonesDrawings(response: models.Calculate.CalculationResult) {
    this.updateCalculationConnectionZonesDrawings(response);
    const observables = [];
    const shearConnectionResult = response.shearConnectionResult;

    for (let _i = 0; _i < shearConnectionResult.numberOfZones; _i++) {
      const compositeCrossSectionDrawing = this.getObservableCompositeCrossSectionDrawing(
        SubProjectComponent.DRAWING_WIDTH,
        SubProjectComponent.DRAWING_HEIGHT,
        shearConnectionResult.listOfNumberOfRows[_i + 1]);
      const compositeBeamDrawing = this.getObservableCompositeBeamDrawing(
        SubProjectComponent.DRAWING_WIDTH,
        SubProjectComponent.DRAWING_HEIGHT,
        shearConnectionResult.listOfNumberOfRows[_i + 1],
        shearConnectionResult.listOfConnectorsSpacing[_i + 1]);
      observables.push(
        observableConcat(
          observableOf(shearConnectionResult.listOfNumberOfConnectors[_i + 1]),
          observableOf(shearConnectionResult.listOfNumberOfRows[_i + 1]),
          observableOf(shearConnectionResult.listOfConnectorsSpacing[_i + 1]),
          observableOf(shearConnectionResult.listOfLeftPosition[_i + 1]),
          observableOf(shearConnectionResult.listOfRightPosition[_i + 1]),
          compositeCrossSectionDrawing,
          compositeBeamDrawing).pipe(toArray()));
    }

    const combine = observableZip(...observables);
    const subscribe = combine.subscribe(zoneStreams => {
      const zones = [];
      if (zoneStreams) {
        for (const zoneStream of zoneStreams) {
          zones.push({
            numberOfConnectors: zoneStream[0],
            numberOfRows: zoneStream[1],
            connectorsSpacing: zoneStream[2],
            leftPosition: zoneStream[3],
            rightPosition: zoneStream[4],
            connectorDrawing1: `data:image/jpg;base64,${zoneStream[5]}`,
            connectorDrawing2: `data:image/jpg;base64,${zoneStream[6]}`
          });
        }
      }
      this.calculateComponent.updateZones(zones);
    }, error => {
      console.log('Error getting the zone drawings');
      this.calculateComponent.updateZones([]);
    });
  }

  private clearCalculationDrawings() {
    this.calculateComponent.updateConnectionZones('');
    this.calculateComponent.updateZones([]);
  }
  private calculate = (): void => {
    if (this.subProjectForm.valid) {
      this.clearCalculationDrawings();
      this.enableReportButton = true;
      const subProject = this.mapModel();
      // Calculate the loads to make sure they are all in sync with the parameters selected
      const o1 = this.getObservableDefaultCompositeSelfWeight();
      const o2 = this.getObservableDefaultLiveLoad();
      const combine = observableZip(o1, o2);
      this.sharedService.showLoader(true);
      this.calculationResponse = null;
      const subscribe = combine.subscribe((defaultLoads: any) => {
        // console.log('Calculate Loads and Drawings ', defaultLoads);
        if (defaultLoads && defaultLoads.length !== 0) {
          this.resetDefaultLoadsOnForm(defaultLoads, false);
        }
        const createCommand = this.getReportData();
        this.calculateInput = createCommand;
        this.calculationsService.getCalculationResults(createCommand).subscribe((response) => {
          this.sharedService.showLoader(false);
          this.calculateError = (!response || (response.errorCodes && response.errorCodes.length > 0));
          if (!this.calculateError) {
            console.log('No errors in Calculations');
            this.handleDesignResult(response);
            this.calculateComponent.updateCalculations(createCommand, response);
            this.calculationResponse = response;
            // Need number of rows to display calculate drawings, hence calling calculation drawings after calling calculate
            // this.updateCalculationDrawings(response);
            this.updateCalculationZonesDrawings(response);
          } else if (this.isCalculationError(response) && this.isPdfError) {
            // If it is just pdf Error then go ahead and call update drawings
            console.log('Errors in Calculations, but they are just pdf Errors');
            this.handleCalculateError();
            this.handleDesignResult(response);
            this.calculateComponent.updateCalculations(createCommand, response);
            // If it is just pdf Error then go ahead and call update drawings
            // this.updateCalculationDrawings(response);
            this.updateCalculationZonesDrawings(response);
          } else {
            // If calculation error and not pdf error then that means there is an issue
            if (this.isCalculationError(response) && !this.isPdfError) {
              this.sharedService.popFailure('calculations-not-ok');
              this.handleCalculateError();
              const errorLabels = response.errorCodes.map(item => 'error-code-' + item);
              console.log('Error Labels ', errorLabels);
              this.calculateComponent.updateErrors(errorLabels);
            }
          }
        }, error => {
          this.calculationResponse = null;
          this.handleCalculateError();
          this.calculateComponent.updateErrors(error ? error.errors : []);
          this.sharedService.popFailure('subproject-calculate-failure');
        }, () => {
          this.sharedService.showLoader(false);
        });
      });
    }
  }

  handleCalculateError = () => {
    this.sharedService.showLoader(false);
    this.enableReportButton = false;
  }

  onTabSelected = (event) => {
    this.selectedTab = event.index;

    if (event.index === SubProjectComponent.CALCULATE) { // calculate Tab
      this.calculate();
    }

    if (event.index === SubProjectComponent.SLAB) {
      this.getSlabDrawing();
    }

    if (event.index === SubProjectComponent.LOADS) {
      this.handleDefaultLoads(true);
    }

    if (event.index === SubProjectComponent.ADDITIONAL_LOADS) {
      this.lineloadsComponent.populateLineLoadsData(this.subProjectModel.load.loadCases[3].lineLoads,
        this.subProjectModel.load.loadCases[1].lineLoads);
      this.pointloadsComponent.populatePointLoadsData(this.subProjectModel.load.loadCases[3].pointLoads,
        this.subProjectModel.load.loadCases[1].pointLoads);
      this.getLiveLineLoadsDrawing();
      this.getDeadLineLoadsDrawing();
      this.getLivePointLoadsDrawing();
      this.getDeadPointLoadsDrawing();
      this.getLoadDrawing(3);
      this.getBeamLoadDrawing(SubProjectComponent.ADDITIONAL_LOAD_DRAWING_WIDTH, SubProjectComponent.LOAD_DRAWING_HEIGHT);
    }

    if (event.index === SubProjectComponent.BEAM_GEOMETRY) {
      this.validateAndDrawBeamGeometry();
    }

    if (event.index === SubProjectComponent.MATERIAL) {
      this.validateAndDrawSteelProfile();
      this.validateAndDrawProfileSheeting();
    }

    if (event.index === SubProjectComponent.CONNECTOR) {
      this.filteredConnectorTypes = this.shearConnectorTypesFiltered() || [];
      this.filteredConnectorOrientations = this.shearConnectorOrientationFiltered();
      this.drawCompositeDrawings();
    }
  }

  resetDefaultLoadsOnForm = (data: any, getDrawings: boolean) => {
    if (data === null || data.length !== 2) {
      return;
    }
    if (this.calculatedSelfWeightDisplay !== UnitHelper.roundLoadFromApi(data[0], this.project.loadUnit)
      || this.calculatedSelfWeightNewtons === 0 || this.subProjectForm.get('userSelfWeight').value === 0) {
      this.calculatedSelfWeightNewtons = data[0];
      this.calculatedSelfWeightDisplay = UnitHelper.roundLoadFromApi(data[0], this.project.loadUnit);
      this.subProjectForm.get('selfWeight').setValue(this.calculatedSelfWeightDisplay);
      this.subProjectForm.get('userSelfWeight').setValue(this.calculatedSelfWeightDisplay);
      this.overrideSelfWeight = false;
      this.subProjectModel.load.userCompositeSelfWeight = this.calculatedSelfWeightDisplay;
    }
    // Set the Live load value to default live load
    if (this.calculatedLiveLoadDisplay !== UnitHelper.roundLoadFromApi(data[1], this.project.loadUnit)
      || this.calculatedLiveLoadNewtons === 0 || this.subProjectForm.get('liveLoad').value === 0) {
      this.calculatedLiveLoadNewtons = data[1];
      this.calculatedLiveLoadDisplay = UnitHelper.roundLoadFromApi(data[1], this.project.loadUnit);
      this.subProjectForm.get('defaultLiveLoad').setValue(this.calculatedLiveLoadDisplay);
      this.subProjectForm.get('liveLoad').setValue(this.calculatedLiveLoadDisplay);
      this.subProjectModel.load.loadCases[2].distributedSurfaceLoad = this.calculatedLiveLoadDisplay;
      this.overrideLiveLoad = false;
    }
    // console.log('Load Tab Clicked, calling Standard Load', this.subProjectModel);
    if (getDrawings) {
      this.getStandardLoadDrawings();
    }
  }

  handleDefaultLoads = (getDrawings: boolean) => {
    const o1 = this.getObservableDefaultCompositeSelfWeight();
    const o2 = this.getObservableDefaultLiveLoad();
    const combine = observableZip(o1, o2);
    const subscribe = combine.subscribe((defaultLoads: any) => {
      // console.log(defaultLoads);
      if (defaultLoads && defaultLoads.length !== 0) {
        this.resetDefaultLoadsOnForm(defaultLoads, getDrawings);
      }
    });
  }

  drawCompositeDrawings = (): void => {
    this.drawCompositeSubject.next();
  }

  debouncedCompositeDrawings = () => {
    this.getCompositeBeamDrawing(SubProjectComponent.DRAWING_WIDTH, SubProjectComponent.DRAWING_HEIGHT, 1);
    this.getCompositeCrossSectionDrawing(SubProjectComponent.DRAWING_WIDTH, SubProjectComponent.DRAWING_HEIGHT, 1);
    // console.log('debouncedCompositeDrawings called');
  }

  backToProject = (): void => {
    this.router.navigate(['/project', { id: this.projectId }]);
  }

  backToProjects = (): void => {
    this.router.navigate(['/projects']);
  }

  private resetLoadIds = (subProject: models.SubProject): void => {
    if (subProject.load && subProject.load.loadCases && subProject.load.loadCases.length > 0) {
      subProject.load.loadCases.forEach(loadcase => {
        loadcase.pointLoads.forEach(pointLoad => {
          pointLoad.id = pointLoad.id > 0 ? pointLoad.id : 0;
        });
        loadcase.lineLoads.forEach(lineLoad => {
          lineLoad.id = lineLoad.id > 0 ? lineLoad.id : 0;
          lineLoad.originLoad.id = lineLoad.originLoad.id > 0 ? lineLoad.originLoad.id : 0;
          lineLoad.endLoad.id = lineLoad.endLoad.id > 0 ? lineLoad.endLoad.id : 0;
        });
      });
    }
  }

  public saveSubProject = (doLeave: boolean): void => {
    if (!this.subProjectForm.valid) {
      this.onSaveFailure('form error', false);
      this.showSaveOnDestroyDialog = false;
      return;
    }
    const updatedModel = this.mapModel();
    updatedModel.load = this.transformLoadsForSave(updatedModel.load);
    console.log('updatedModel  ->', JSON.stringify(updatedModel));
    this.sharedService.showLoader(true);
    if (this.subProjectId > 0) {
      // console.log('Saving Sub project = ', updatedModel);
      this.subProjectService.updateSubProject(updatedModel)
        .subscribe(
          (project) => this.onSaveComplete(project, doLeave),
          (error: any) => this.onSaveFailure(error, false),
          () => this.sharedService.showLoader(false));
    } else {
      // console.log('Create Sub project = ', updatedModel);
      this.subProjectService.createSubProject(updatedModel)
        .subscribe(
          (project) => this.onSaveComplete(project, doLeave),
          (error: any) => this.onSaveFailure(error, false),
          () => this.sharedService.showLoader(false));
    }
  }

  private onSaveComplete = (subproject, doLeave: boolean): void => {
    this.subProjectForm.markAsPristine();
    this._saveOnLeaveSubject.next(doLeave);
    this.sharedService.showLoader(false);
    if (this.isNew) {
      this.sharedService.popSuccess('subproject-create-success');
      this.isNew = false;
    } else {
      this.sharedService.popSuccess('subproject-save-success');
    }
  }

  private onSaveFailure = (error, doLeave: boolean): void => {
    this._saveOnLeaveSubject.next(doLeave);
    this.sharedService.showLoader(false);
    if (this.isNew) {
      this.sharedService.popFailure('subproject-create-failure');
    } else {
      this.sharedService.popFailure('subproject-save-failure');
    }
  }

  public saveAsSubProject() {
    this.saveAsSubProjectName = '';
    this.showSaveAsSubProjectDialog = true;
  }

  public createNewSubProjectAndOpen = (): void => {
    const copiedSubProject = this.mapModel();
    const load = this.transformLoadsForSave(copiedSubProject.load);
    copiedSubProject.load = load;
    copiedSubProject.id = 0;
    copiedSubProject.concreteSlab.id = 0;
    copiedSubProject.deformation.id = 0;
    copiedSubProject.load.id = 0;
    copiedSubProject.name = this.saveAsSubProjectName;
    copiedSubProject.profileSheeting.id = 0;
    copiedSubProject.reinforcement.id = 0;
    copiedSubProject.shearConnector.id = 0;
    copiedSubProject.steelProfile.id = 0;
    this.subProjectForm.markAsPristine();
    if (this.saveAsSubProjectName && this.saveAsSubProjectName.length >= 3 &&
      this.isSaveAsSubProjectNameUnique(this.saveAsSubProjectName)) {
      this.disableCreateButton = true;
      this.sharedService.showLoader(true);
      this.subProjectService.createSubProject(copiedSubProject)
        .subscribe((subProject) => this.onSaveAsComplete(subProject),
          (error) => this.onSaveAsFailure(error),
          () => {
            this.sharedService.showLoader(false);
            this.disableCreateButton = false;
          });
      this.showSaveAsSubProjectDialog = false;
    }
  }

  private onSaveAsComplete(subProject) {
    this.sharedService.showLoader(false);
    this.sharedService.popSuccess('subproject-create-success');
    this.subProjectId = subProject.id;
    this.init();
    this.router.navigate(['/subproject', { projectId: this.project.id, id: subProject.id }]);
  }

  private onSaveAsFailure(error) {
    this.sharedService.popFailure('subproject-create-failure');
  }

  initializeLoadCases = (): void => {

  }

  getPartialFactorFromProject = (project: models.Project): models.PartialFactor => {
    return {
      id: 0, // TODO Nejc: create new interface for project PartialFactor values
      nationalAnnexId: 0, // TODO Nejc: create new interface for project PartialFactor values
      gammaC: project.concrete,
      gammaG: project.ulsGammaG,
      gammaM0: project.structuralSteelSection,
      gammaM1: project.structuralSteelElement,
      gammaQ: project.ulsGammaQ,
      gammaS: project.reinforcement,
      gammaV: project.connector,
      gammaP: project.steelProfile,
      asPhiM: project.asPhiM,
      asPhiMb: project.asPhiMb,
      asPhiVc: project.asPhiVc,
      asPhiVm: project.asPhiVm,
      asPhiS: project.asPhiS,
      asPhiC: project.asPhiC,
      asPhiVf: project.asPhiVf,
      asPhiSC: project.asPhiSC,
      asPhiSR: project.asPhiSR
    };
  }


  private mapModel = (): models.SubProject => {
    const subProject: models.SubProject = {
      'id': this.subProjectId || 0,
      'loadCategory': this.subProjectForm.value.loadCategory.id,
      'combinationFactor': this.subProjectForm.value.combinationFactor,
      'liveLoadReduction': this.subProjectForm.value.liveLoadReduction,
      'projectId': this.projectId,
      'createdOn': this.subProjectModel.createdOn,
      'name': this.subProjectForm.value.subprojectName,
      'beamGeometry': this.getBeamGeometryObject(true),
      'steelProfile': this.getSteelProfileObject(false),
      'concreteSlab': this.getConcreteSlabObject(false),
      'reinforcement': {
        'id': this.subProjectModel.reinforcement && this.subProjectModel.reinforcement.id || 0,
        'steelGradeId': this.subProjectForm.value.reinforcementType ? this.subProjectForm.value.reinforcementType.id : 0,
      },
      'profileSheeting': this.getProfileSheetingObject(false),
      'partialFactors': this.partialFactor,
      'shearConnector': {
        'id': this.subProjectModel.shearConnector && this.subProjectModel.shearConnector.id || 0,
        'connectionDegreeId': this.subProjectForm.value.shearConnectionDegree && this.subProjectForm.value.shearConnectionDegree.id || 0,
        'connectorTypeId': this.subProjectForm.value.shearConnectionType && this.subProjectForm.value.shearConnectionType.id || 0,
        'connectorsOrientationId': (<any>this.subProjectForm).controls.shearConnectionOrientation.value
          ? +(<any>this.subProjectForm).controls.shearConnectionOrientation.value.id : 0,
        'userConnectionDegree': this.subProjectForm.value.userConnectionDegree,
        'optimizationOption': +!this.subProjectForm.value.optimizationOption
      },
      'load': {
        'id': this.subProjectModel.load && this.subProjectModel.load.id || 0,
        'loadCases': this.subProjectModel.load ? this.subProjectModel.load.loadCases : [],
        'userCompositeSelfWeight': this.subProjectModel.load ? this.subProjectModel.load.userCompositeSelfWeight : 0
      },
      'deformation': {
        'id': this.subProjectModel.deformation && this.subProjectModel.deformation.id || 0,
        'constructionTypeId': this.subProjectForm.value.constructionType && this.subProjectForm.value.constructionType.id || 0,
        'precamber': this.subProjectForm.value.precamber || 0,
        'frequencyLimit': this.subProjectForm.value.frequencyLimit || 3,
        'totalDeflectionLimit': this.subProjectForm.value.totalLoadDeflection && this.subProjectForm.value.totalLoadDeflection.id || 0,
        'compositeDeflectionLimit': this.subProjectForm.value.deflectionLimit && this.subProjectForm.value.deflectionLimit.id || 0,
        'percentageLiveLoad': this.subProjectForm.value.liveLoadPercentage && this.subProjectForm.value.liveLoadPercentage.id || 0,
        'dampling': this.subProjectForm.getRawValue().dampling && this.subProjectForm.getRawValue().dampling.id || 0,
        'walkingActivity': (this.subProjectForm.value.walkingActivity ? this.subProjectForm.value.walkingActivity.id : 1),
        'walkingExcitationCheck': +this.subProjectForm.value.walkingExcitation,
        'rhythmicExcitationCheck': +this.subProjectForm.value.rhythmicExcitationCheck || 0,
        'rhythmicActivity': this.subProjectForm.getRawValue().rhythmicActivity.id || 0,
        'permanentLoadFraction': +this.subProjectForm.getRawValue().permanentLoadFraction || 0,
        'incrementalDeflectionCheck': +this.subProjectForm.getRawValue().incrementalDeflectionCheck || 0,
        'performLateralTorsionBucklingCheck': +this.subProjectForm.getRawValue().performLateralTorsionBucklingCheck || 0,
      },
      'designCode': this.project.designCode
    };
    this.resetLoadIds(subProject); // Reset LoadIds for inserts
    return subProject;
  }

  isValidSolidSlab = (): boolean => {
    if (this.subProjectForm.value.slabThickness > 0 && this.subProjectForm.value.slabType.value === 0) {
      return true;
    } else {
      return false;
    }
  }

  isValidSteelGrade = (): boolean => {
    if (this.subProjectForm.value.steelGrade && this.subProjectForm.value.steelGrade.value === 3) {
      if (this.subProjectForm.value.steelProfileCustomSteelGradeYieldStrength >= 170 &&
        this.subProjectForm.value.steelProfileCustomSteelGradeYieldStrength <= 355) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  isValidSteelProfileType = (): boolean => {
    if (this.subProjectForm.value.profileType && this.subProjectForm.value.profileType.profileRange === 'Custom') {
      const isWebThicknessValid = (<any>this.subProjectForm).controls.steelProfileCustomWebThickness.valid;
      const isFlangeThicknessValid = (<any>this.subProjectForm).controls.steelProfileCustomFlangeThickness.valid;
      const isHeightValid = (<any>this.subProjectForm).controls.steelProfileCustomHeight.valid;
      return isWebThicknessValid && isFlangeThicknessValid && isWebThicknessValid && isHeightValid;
    } else {
      return true;
    }
  }


  isValidSteelProfile = (): boolean => {
    if (this.subProjectForm.value.steelProfile &&
      this.subProjectForm.value.steelProfile.label && this.subProjectForm.value.steelGrade && this.subProjectForm.value.steelGrade.id) {
      return this.isValidSteelProfileType();
    } else {
      return false;
    }
  }


  getSlabDrawing = (): void => {
    this.getSlabDrawing1(SubProjectComponent.DRAWING_WIDTH, SubProjectComponent.DRAWING_HEIGHT);
    this.getSlabDrawing2(SubProjectComponent.DRAWING_WIDTH, SubProjectComponent.DRAWING_HEIGHT);

  }

  getSteelSectionDrawing = (width, height) => {
    if (!this.isValidSteelProfile()) {
      // Reset drwaings if the input is not valid
      this.steelSectionDrawingStream1 = '';
      this.steelSectionDrawingStream2 = '';
      return;
    }
    const sp: models.SteelSectionDrawing = {
      'steelProfile': this.getSteelProfileObject(true),
      'pictureWidth': width ? width : 400,
      'pictureHeight': height ? height : 400,
      'drawingType': 0,
      'lengthUnit': this.getUnitSystemValue(this.project.unit) === 0 ? 2 : 1,
      'showSymbol': false,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };

    this.calculationsService.getSteelSectionDrawing(sp).subscribe(drawing => {
      this.steelSectionDrawingStream1 = `data:image/jpg;base64,${drawing}`;
    });

    sp.drawingType = 1;
    sp.pictureHeight = width ? width : 400;
    sp.pictureWidth = height ? height : 400;
    this.calculationsService.getSteelSectionDrawing(sp).subscribe(drawing => {
      this.steelSectionDrawingStream2 = `data:image/jpg;base64,${drawing}`;
    });
  }

  isValidBeamGeometryDrawing = (): boolean => {
    if (
      this.subProjectForm &&
      this.subProjectForm.value.beamLength
      && this.subProjectForm.value.beamSpacingLeft
      && this.subProjectForm.value.beamSpacingRight
      && this.subProjectForm.value.beamLocation.id) {
      return true;
    } else {
      return false;
    }
  }

  getSteelProfileObject = (calculations: boolean): any => {
    const profileUnit = this.subProjectForm.value.steelProfile.unitSystem;
    const isCustomSteelProfile = this.subProjectForm.value.steelProfile && this.subProjectForm.value.steelProfile.label === 'Custom';
    const isCustomSteelGrade = this.subProjectForm.value.steelGrade && this.subProjectForm.value.steelGrade.label === 'Custom';
    if (calculations) {
      return {
        'id': this.subProjectModel.steelProfile && this.subProjectModel.steelProfile.id || 0,
        'profileName': this.subProjectForm.value.steelProfile.label,
        'steelGradeId': this.subProjectForm.value.steelGrade ? +this.subProjectForm.value.steelGrade.id : 0,
        'steelStandardNZS': this.subProjectForm.value.steelStandardNZS ? +this.subProjectForm.value.steelStandardNZS.value : 0,
        'steelGradeValue': this.subProjectForm.value.steelGrade ? +this.subProjectForm.value.steelGrade.value : 0,
        // tslint:disable-next-line:max-line-length
        'height': isCustomSteelProfile ? UnitHelper.roundToUniverseLength(this.subProjectForm.value.steelProfileCustomHeight, this.project.unit)
          : UnitHelper.roundToUniverseLength(this.subProjectForm.value.steelProfile.height, this.project.unit, profileUnit),
        'flangeWidth': isCustomSteelProfile ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfileCustomFlangeWidth, this.project.unit)
          : UnitHelper.roundToUniverseLength(this.subProjectForm.value.steelProfile.flangeWidth, this.project.unit, profileUnit),
        'webThickness': isCustomSteelProfile ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfileCustomWebThickness, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.webThickness, this.project.unit, profileUnit),
        'flangeThickness': isCustomSteelProfile ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfileCustomFlangeThickness, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.flangeThickness, this.project.unit, profileUnit),
        'rootRadius': isCustomSteelProfile ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfileCustomRootRadius, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.rootRadius, this.project.unit, profileUnit),
        'radius': isCustomSteelProfile ? 0 : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.radius, this.project.unit, profileUnit),
        'customProfile': isCustomSteelProfile,
        'yieldStrength': isCustomSteelGrade ?
          UnitHelper.getYieldStrength(+this.subProjectForm.value.steelProfileCustomSteelGradeYieldStrength, this.project.unit, this.project.unit) : 0,
        'elasticImposed': this.subProjectForm.value.elasticImposed
      };
    } else {
      let height = UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.height, this.project.unit, profileUnit, 'mm');
      height = height < this.validationValues.steelProfileCustomHeight.min ? this.validationValues.steelProfileCustomHeight.min : height;
      return {
        'id': this.subProjectModel.steelProfile && this.subProjectModel.steelProfile.id || 0,
        'profileName': this.subProjectForm.value.steelProfile ? this.subProjectForm.value.steelProfile.label : '',
        'steelGradeId': this.subProjectForm.value.steelGrade ? +this.subProjectForm.value.steelGrade.id : 0,
        'steelStandardNZS': this.subProjectForm.value.steelStandardNZS ? +this.subProjectForm.value.steelStandardNZS.id : 0,
        'steelGradeValue': this.subProjectForm.value.steelGrade ? +this.subProjectForm.value.steelGrade.value : 0,
        'height': isCustomSteelProfile ? +this.subProjectForm.value.steelProfileCustomHeight :
          (this.subProjectForm.value.steelProfile ? height : 0),
        'flangeWidth': isCustomSteelProfile ?
          +this.subProjectForm.value.steelProfileCustomFlangeWidth :
          (this.subProjectForm.value.steelProfile ?
            UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.flangeWidth, this.project.unit, profileUnit, 'mm') : 0),
        'webThickness': isCustomSteelProfile ?
          +this.subProjectForm.value.steelProfileCustomWebThickness
          : (this.subProjectForm.value.steelProfile ?
            UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.webThickness, this.project.unit, profileUnit, 'mm') : 0),
        'flangeThickness': isCustomSteelProfile ?
          this.subProjectForm.value.steelProfileCustomFlangeThickness :
          (this.subProjectForm.value.steelProfile ?
            UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.flangeThickness, this.project.unit, profileUnit, 'mm') : 0),
        'rootRadius': isCustomSteelProfile ?
          +this.subProjectForm.value.steelProfileCustomRootRadius :
          (this.subProjectForm.value.steelProfile ?
            UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.rootRadius, this.project.unit, profileUnit, 'mm') : 0),
        'radius': isCustomSteelProfile ? 0 : (this.subProjectForm.value.steelProfile ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.steelProfile.radius, this.project.unit, profileUnit, 'mm') : 0),
        'customProfile': isCustomSteelProfile,
        'yieldStrength': isCustomSteelGrade ?
          this.project.unit === AppConstants.UNIT_SYSTEM_MI ? +this.subProjectForm.value.steelProfileCustomSteelGradeYieldStrength :
            UnitHelper.getYieldStrength(+this.subProjectForm.value.steelProfileCustomSteelGradeYieldStrength, this.project.unit, this.project.unit) : 0,
        'elasticImposed': this.subProjectForm.value.elasticImposed
      };
    }
  }

  //
  // Some drawings need mm as a length, otherwise we send meters to the calculation module
  // The default units for calculation -  length for meters and newtons for force
  // Only exception is for some drawigns we need to send mm.
  //


  getBeamGeometryObject = (isInternal: boolean): any => {
    return {
      'id': this.subProjectModel.beamGeometry && this.subProjectModel.beamGeometry.id || 0,
      'beamDesign': +this.subProjectForm.value.beamDesign.id,
      'beamLength': isInternal ?
        this.subProjectForm.value.beamLength : UnitHelper.roundToNonUniverseLength(this.subProjectForm.value.beamLength, this.project.unit),
      'leftSpacing': isInternal ?
        this.subProjectForm.value.beamSpacingLeft : UnitHelper.roundToNonUniverseLength(this.subProjectForm.value.beamSpacingLeft, this.project.unit),
      'rightSpacing': isInternal ?
        this.subProjectForm.value.beamSpacingRight : UnitHelper.roundToNonUniverseLength(this.subProjectForm.value.beamSpacingRight, this.project.unit),
      'beamTypeId': 2, // Simply Supported Beam
      'beamTypeValue': 1, // Simply Supported Beam
      'beamLocationId': +this.subProjectForm.value.beamLocation.id,
      'beamLocationValue': +this.subProjectForm.value.beamLocation.value,
      'slabTypeId': +this.subProjectForm.value.slabType.id,
      'slabTypeValue': +this.subProjectForm.value.slabType.value,
      'leftOpening': this.subProjectForm.value.leftOpening,
      'leftOpeningPosition': isInternal ? this.subProjectForm.value.leftOpeningPosition :
        UnitHelper.roundToNonUniverseLength(this.subProjectForm.value.leftOpeningPosition, this.project.unit),
      'rightOpening': this.subProjectForm.value.rightOpening,
      'rightOpeningPosition': isInternal ? this.subProjectForm.value.rightOpeningPosition :
        UnitHelper.roundToNonUniverseLength(this.subProjectForm.value.rightOpeningPosition, this.project.unit)
    };
  }

  getShearConnectorObject = (): any => {
    return {
      'connectionDegreeId': +(<any>this.subProjectForm).controls.shearConnectionDegree.value.id,
      'connectionDegreeValue': +(<any>this.subProjectForm).controls.shearConnectionDegree.value.value,
      'connectorTypeId': +(<any>this.subProjectForm).controls.shearConnectionType.value.id,
      'connectorTypeValue': +(<any>this.subProjectForm).controls.shearConnectionType.value.value,
      'connectorsOrientationId': +(<any>this.subProjectForm).controls.shearConnectionOrientation.value.id,
      'connectorsOrientationValue': +(<any>this.subProjectForm).controls.shearConnectionOrientation.value.value,
      'userConnectionDegree': (+(<any>this.subProjectForm).controls.userConnectionDegree.value) / 100,
      'optimizationOption': +!(<any>this.subProjectForm).controls.optimizationOption.value
    };
  }

  getProfileSheetingObject = (calculations: boolean): any => {
    if (this.subProjectForm.value.slabType.value === 0) { // If it is solid slab then do not validate profile sheeting
      return {
        id: this.subProjectModel.profileSheeting && this.subProjectModel.profileSheeting.id || 0,
      };
    } else {
      if (!this.subProjectForm.value.profiledSheetingType) {
        this.subProjectForm.get('haunchHeight').setValue(0);
        this.setProfileSheeting(); // Set the default values for Profile Sheeting
        this.getSlabDrawing();
      }
    }

    const isCustom = this.subProjectForm.value.profiledSheetingType ?
      this.subProjectForm.value.profiledSheetingType.label === 'Custom' : false;
    const sourceUnitSystem = isCustom ? this.project.unit : +this.subProjectForm.value.profiledSheetingType.unitSystem;
    const transformUnits = sourceUnitSystem !== this.project.unit ? true : false;
    if (calculations !== undefined && calculations === true) {
      return {
        'id': this.subProjectModel.profileSheeting && this.subProjectModel.profileSheeting.id || 0,
        'profileName': this.subProjectForm.value.profiledSheetingType ? this.subProjectForm.value.profiledSheetingType.label : '',
        'sheetingOrientationId': +this.subProjectForm.value.profiledSheetingOrientation.id,
        'sheetingOrientationValue': +this.subProjectForm.value.profiledSheetingOrientation.value,
        'pitch': isCustom ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingCustomTroughSpacing, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.pitch, this.project.unit,
            sourceUnitSystem),
        'ribBottomWidth': isCustom ?
          +UnitHelper.roundToUniverseLength(this.subProjectForm.value.profiledSheetingCustomBottomWidth, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribBottomWidth, this.project.unit,
            sourceUnitSystem),
        'ribTopWidth': isCustom ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingCustomTopWidth, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribTopWidth, this.project.unit,
            sourceUnitSystem),
        'ribHeight': isCustom ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingCustomDeckDepth, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribHeight, this.project.unit,
            sourceUnitSystem),
        'thickness': isCustom ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingCustomThickness, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.thickness, this.project.unit,
            sourceUnitSystem),
        'surfaceWeight': isCustom ?
          UnitHelper.getStressValue(+this.subProjectForm.value.profiledSheetingCustomSurfaceWeight, this.project.unit, sourceUnitSystem)
          : UnitHelper.getStressValue(this.subProjectForm.value.profiledSheetingType.surfaceWeight, this.project.unit,
            sourceUnitSystem),
        'numberRibStiffeners': isCustom ?
          this.subProjectForm.value.profiledSheetingCustomNumberRibStiffeners
          : this.subProjectForm.value.profiledSheetingType.numberRibStiffeners,
        'ribStiffenerWidth': isCustom ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingCustomRibStiffenerWidth, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribStiffenerWidth, this.project.unit,
            sourceUnitSystem),
        'stiffenersSpacing': isCustom ?
          UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingCustomStiffenersSpacing, this.project.unit)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.stiffenersSpacing, this.project.unit,
            sourceUnitSystem),
        'continuousForPerpendicular': true,
        'yieldStrength': isCustom ?
          UnitHelper.getYieldStrength(+this.subProjectForm.value.profiledSheetingCustomYieldStrength, this.project.unit, sourceUnitSystem)
          : (this.subProjectForm.value.profiledSheetingType ?
            UnitHelper.getYieldStrength(+this.subProjectForm.value.profiledSheetingType.yieldStrength, this.project.unit,
              sourceUnitSystem) : 0),
        'topStiffenerHeight': isCustom ?
          UnitHelper.roundToUniverseLength(this.subProjectModel.profileSheeting && this.subProjectModel.profileSheeting.topStiffenerHeight || 0, this.project.unit,
            sourceUnitSystem)
          : UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.topStiffenerHeight, this.project.unit,
            sourceUnitSystem),
      };
    } else {
      return {
        'id': this.subProjectModel.profileSheeting && this.subProjectModel.profileSheeting.id || 0,
        'profileName': this.subProjectForm.value.profiledSheetingType ? this.subProjectForm.value.profiledSheetingType.label : '',
        'sheetingOrientationId': +this.subProjectForm.value.profiledSheetingOrientation.id,
        'sheetingOrientationValue': +this.subProjectForm.value.profiledSheetingOrientation.value,
        'pitch': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomTroughSpacing
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.pitch,
            this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.pitch,
        'ribBottomWidth': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomBottomWidth
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribBottomWidth,
            this.project.unit, sourceUnitSystem) : + this.subProjectForm.value.profiledSheetingType.ribBottomWidth,
        'ribTopWidth': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomTopWidth
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribTopWidth,
            this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.ribTopWidth,
        'ribHeight': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomDeckDepth
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribHeight,
            this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.ribHeight,
        'thickness': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomThickness
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.thickness,
            this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.thickness,
        'surfaceWeight': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomSurfaceWeight
          : transformUnits ? UnitHelper.convertKgM2ToLbFt2(+this.subProjectForm.value.profiledSheetingType.surfaceWeight) :
            +this.subProjectForm.value.profiledSheetingType.surfaceWeight,
        'numberRibStiffeners': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomNumberRibStiffeners
          : +this.subProjectForm.value.profiledSheetingType.numberRibStiffeners,
        'ribStiffenerWidth': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomRibStiffenerWidth
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.ribStiffenerWidth,
            this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.ribStiffenerWidth,
        'stiffenersSpacing': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomStiffenersSpacing
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.stiffenersSpacing,
            this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.stiffenersSpacing,
        'continuousForPerpendicular': true,
        'yieldStrength': isCustom ?
          +this.subProjectForm.value.profiledSheetingCustomYieldStrength
          : (this.subProjectForm.value.profiledSheetingType ? (
            transformUnits ? UnitHelper.getYieldStrength(+this.subProjectForm.value.profiledSheetingType.yieldStrength,
              this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.yieldStrength) : 0),
        'topStiffenerHeight': isCustom ?
          this.subProjectModel.profileSheeting && this.subProjectModel.profileSheeting.topStiffenerHeight || 0
          : transformUnits ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.profiledSheetingType.topStiffenerHeight,
            this.project.unit, sourceUnitSystem) : +this.subProjectForm.value.profiledSheetingType.topStiffenerHeight,
      };
    }
  }

  getConcreteSlabObject = (calculations: boolean): any => {
    if (calculations !== undefined && calculations === true) {
      return {
        'id': this.subProjectModel.concreteSlab && this.subProjectModel.concreteSlab.id || 0,
        'slabThickness': UnitHelper.roundToUniverseLength(+this.subProjectForm.value.slabThickness, this.project.unit),
        // tslint:disable-next-line:max-line-length
        'haunchHeight': this.subProjectForm.value.slabType.value === 0 ? UnitHelper.roundToUniverseLength(+this.subProjectForm.value.haunchHeight, this.project.unit) : 0,
        'concreteTypeId': +this.subProjectForm.value.concreteType.id,
        'concreteTypeValue': +this.subProjectForm.value.concreteType.value,
        'concreteClassId': +this.subProjectForm.value.concreteClass.id,
        'concreteClassValue': this.project.designCode === 3 ? +this.subProjectForm.value.concreteStrength.value : +this.subProjectForm.value.concreteClass.value,
        'concreteDensity': UnitHelper.getDensity(this.subProjectForm.value.concreteDensity, this.project.unit),
        'aggregatesDensity': UnitHelper.getDensity(this.subProjectForm.value.aggregatesDensity, this.project.unit),
        'coverRequired': this.subProjectForm.value.coverRequired,
        'concreteStrengthUS': this.subProjectForm.value.concreteStrength.label === 'Custom' ?
          UnitHelper.getConcreteStrength(+this.subProjectForm.value.concreteStrengthUS, this.project.unit)
          : UnitHelper.getConcreteStrength(this.subProjectForm.value.concreteStrength.value, this.project.unit),
        'concreteStrengthId': this.subProjectForm.value.concreteStrength.id,
      };
    } else {
      return {
        'id': this.subProjectModel.concreteSlab && this.subProjectModel.concreteSlab.id || 0,
        'slabThickness': this.subProjectForm.value.slabThickness,
        'haunchHeight': this.subProjectForm.value.slabType.value === 0 ? +this.subProjectForm.value.haunchHeight : 0,
        'concreteTypeId': +this.subProjectForm.value.concreteType.id,
        'concreteTypeValue': +this.subProjectForm.value.concreteType.value,
        'concreteClassId': +this.subProjectForm.value.concreteClass.id,
        'concreteClassValue': +this.subProjectForm.value.concreteClass.value,
        'concreteDensity': +this.subProjectForm.value.concreteDensity,
        'aggregatesDensity': +this.subProjectForm.value.aggregatesDensity,
        'coverRequired': this.subProjectForm.value.coverRequired,
        'concreteStrengthUS': this.subProjectForm.value.concreteStrength.label === 'Custom' ? +this.subProjectForm.value.concreteStrengthUS
          : (this.project.designCode === 3 ? this.subProjectForm.value.concreteStrength.label : this.subProjectForm.value.concreteStrength.value),
        'concreteStrengthId': this.subProjectForm.value.concreteStrength.id,
      };
    }
  }

  getBeamGeometryDrawing = (width, height): void => {
    if (!this.isValidBeamGeometryDrawing()) {
      return;
    }
    const sp: models.BeamGeometryDrawing = {
      'beamGeometry': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? this.getBeamGeometryObject(true) : this.getBeamGeometryObject(false), // For Beam Geometry drawing we will draw in meters
      'pictureWidth': +width,
      'pictureHeight': +height,
      'showSymbol': true,
      'lengthUnit': this.dropDownOptions.lengthUnits.find(lu => lu.id === this.project.lengthUnit).value,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };
    this.calculationsService.getBeamGeometryDrawing(sp).subscribe(drawing => {
      this.beamGeometryDrawingStream = `data:image/jpg;base64,${drawing}`;
    });
  }



  isValidCustomProfileSheeting = (): boolean => {
    const isYieldStrengthValid = (<any>this.subProjectForm).controls.profiledSheetingCustomYieldStrength.valid;
    const isThicknessValid = (<any>this.subProjectForm).controls.profiledSheetingCustomThickness.valid;
    const isDeckDepthValid = (<any>this.subProjectForm).controls.profiledSheetingCustomDeckDepth.valid;
    const isTopWidthValid = (<any>this.subProjectForm).controls.profiledSheetingCustomTopWidth.valid;
    const isBottomWidthValid = (<any>this.subProjectForm).controls.profiledSheetingCustomBottomWidth.valid;
    const isDeckWeightValid = (<any>this.subProjectForm).controls.profiledSheetingCustomSurfaceWeight.valid;

    const isTroughSpacingValid = (<any>this.subProjectForm).controls.profiledSheetingCustomTroughSpacing.valid;

    const isNumberRibStiffenersValid = (<any>this.subProjectForm).controls.profiledSheetingCustomNumberRibStiffeners.valid;
    const isRibStiffenerWidthValid = (<any>this.subProjectForm).controls.profiledSheetingCustomRibStiffenerWidth.valid;
    const isStiffenersSpacingValid = (<any>this.subProjectForm).controls.profiledSheetingCustomStiffenersSpacing.valid;
    return isYieldStrengthValid && isThicknessValid && isDeckDepthValid && isTopWidthValid && isBottomWidthValid
      && isDeckWeightValid && isTroughSpacingValid && isNumberRibStiffenersValid && isRibStiffenerWidthValid && isStiffenersSpacingValid;
  }

  isValidSlabOrSheeting = (): boolean => {
    if (this.subProjectForm.value.slabType.value === 0) {
      return this.isValidSolidSlab();
    }
    if (this.subProjectForm.value.profiledSheetingType && this.subProjectForm.value.profiledSheetingType.label === 'Custom') {
      return this.isValidCustomProfileSheeting();
    } else {
      return this.subProjectForm.value.profiledSheetingType && this.subProjectForm.value.profiledSheetingType.label
        && this.subProjectForm.value.profiledSheetingOrientation && this.subProjectForm.value.profiledSheetingOrientation.id;
    }
  }

  getProfiledSheetingDrawing = (width, height): void => {
    if (!this.isValidSlabOrSheeting()) {
      this.profiledSheetingDrawing = '';
      return;
    }
    const sp: models.ProfiledSheetingDrawing = {
      'profileSheeting': this.getProfileSheetingObject(true),
      'pictureWidth': width ? +width : SubProjectComponent.DRAWING_WIDTH,
      'pictureHeight': height ? +height : 600,
      'showSymbol': true,
      'lengthUnit': this.dropDownOptions.lengthUnits.find(lu => lu.id === this.project.lengthUnit).value,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };

    this.calculationsService.getProfiledSheetingDrawing(sp).subscribe(drawing => {
      this.profiledSheetingDrawing = `data:image/jpg;base64,${drawing}`;
    });
  }

  isValidCompositeCrossSectionDrawing = (): boolean => {
    return this.isValidCompositeDrawing();
  }

  getCompositeCrossSectionRequestObject = (width: number, height: number, numberOfRows: number): models.CompositeCrossSectionDrawing => {
    const sp: models.CompositeCrossSectionDrawing = {
      'beamGeometry': this.getBeamGeometryObject(false), // This drawing will be in millimeters hence need to convert
      'concreteSlab': this.getConcreteSlabObject(true),
      'profileSheeting': this.subProjectForm.value.slabType.value === 1 ? this.getProfileSheetingObject(true) : {},
      'shearConnector': this.getShearConnectorObject(),
      'steelProfile': this.getSteelProfileObject(true),
      'pictureWidth': +width,
      'pictureHeight': +height,
      'showSymbol': true,
      'numberOfRows': numberOfRows,
      'lengthUnit': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? 2 : 1,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };
    return sp;
  }

  getCompositeCrossSectionDrawing = (width: number, height: number, numberOfRows: number): void => {
    if (!this.isValidCompositeDrawing()) {
      this.compositeCrossSectionDrawing = '';
      return;
    }
    const sp: models.CompositeCrossSectionDrawing = this.getCompositeCrossSectionRequestObject(width, height, numberOfRows);

    this.calculationsService.getCompositeCrossSectionDrawing(sp).subscribe(drawing => {
      this.compositeCrossSectionDrawing = `data:image/jpg;base64,${drawing}`;
    });
  }

  getObservableCompositeCrossSectionDrawing = (width: number, height: number, numberOfRows: number): Observable<any> => {
    if (!this.isValidCompositeCrossSectionDrawing()) {
      this.compositeCrossSectionDrawing = '';
      return;
    }
    const sp = this.getCompositeCrossSectionRequestObject(width, height, numberOfRows);

    return this.calculationsService.getCompositeCrossSectionDrawing(sp);
  }

  isValidShearConnector = (): boolean => {
    if (this.subProjectForm.value.shearConnectionDegree
      && this.subProjectForm.value.shearConnectionType) {
      if (this.subProjectForm.value.shearConnectionOrientation === undefined) {
        this.filteredConnectorOrientations = this.shearConnectorOrientationFiltered();
        if (this.filteredConnectorOrientations != null && this.filteredConnectorOrientations.length !== 0) {
          this.subProjectForm.get('shearConnectionOrientation').setValue(_.last(this.filteredConnectorOrientations), { emitEvent: false, emitViewToModelChange: false, emitModelToViewChange: true });
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  isValidSlabDrawing = (): boolean => {
    return (this.isValidBeamGeometryDrawing() && this.isValidSteelProfile() &&
      this.isValidSlabOrSheeting());
  }

  isValidCompositeDrawing = (): boolean => {
    if (this.isValidBeamGeometryDrawing() && this.isValidSteelProfile()) {
      const validSheeting = this.isValidSlabOrSheeting();
      const validConnector = this.isValidShearConnector();
      return validSheeting && validConnector;
    } else {
      return false;
    }
  }

  getSlabDrawing1 = (width: number, height: number): void => {
    if (!this.isValidSlabDrawing()) {
      this.slabDrawing1 = '';
      return;
    }
    const sp: models.SlabDrawing = {
      'beamGeometry': this.getBeamGeometryObject(false),  // This drawing will be in millimeters hence need to convert
      'concreteSlab': this.getConcreteSlabObject(true), // //This drawing will be in millimeters hence no need to convert
      // This drawing will be in millimeters hence no need to convert
      'profileSheeting': this.subProjectForm.value.slabType.value === 1 ? this.getProfileSheetingObject(true) : {},
      // This drawing will be in millimeters hence no need to convert
      'steelProfile': this.getSteelProfileObject(true),
      'pictureWidth': +width,
      'pictureHeight': +height,
      'showSymbol': true,
      'lengthUnit': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? 2 : 1,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };
    this.calculationsService.getSlabDrawing1(sp).subscribe(drawing => {
      this.slabDrawing1 = `data:image/jpg;base64,${drawing}`;
    });
  }

  getSlabDrawing2 = (width: number, height: number): void => {
    if (!this.isValidSlabDrawing()) {
      this.slabDrawing2 = '';
      return;
    }
    const sp: models.SlabDrawing = {
      'beamGeometry': this.getBeamGeometryObject(false),  // This drawing will be in millimeters hence need to convert
      'concreteSlab': this.getConcreteSlabObject(true), // //This drawing will be in millimeters hence no need to convert
      // This drawing will be in millimeters hence no need to convert
      'profileSheeting': this.subProjectForm.value.slabType.value === 1 ? this.getProfileSheetingObject(true) : {},
      // This drawing will be in millimeters hence no need to convert
      'steelProfile': this.getSteelProfileObject(true),
      'pictureWidth': +width,
      'pictureHeight': +height,
      'showSymbol': true,
      'lengthUnit': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? 2 : 1,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };

    this.calculationsService.getSlabDrawing2(sp).subscribe(drawing => {
      this.slabDrawing2 = `data:image/jpg;base64,${drawing}`;
    });
  }

  getBeamLoadDrawing = (width: number, height: number): void => {
    if (!(this.isValidBeamGeometryDrawing() && this.isValidSteelProfile())) {
      this.beamLoadDrawing = '';
      this.beamLoadDrawing1 = '';
      return;
    }
    const sp: models.BeamLoadDrawing = {
      'beamGeometry': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? this.getBeamGeometryObject(true) : this.getBeamGeometryObject(false),
      'steelProfile': this.getSteelProfileObject(true),
      'pictureWidth': +width,
      'pictureHeight': +height,
      'showSymbol': true,
      'lengthUnit': this.dropDownOptions.lengthUnits.find(lu => lu.id === this.project.lengthUnit).value,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };

    this.calculationsService.getBeamLoadDrawing(sp).subscribe(drawing => {
      this.beamLoadDrawing = `data:image/jpg;base64,${drawing}`;
      this.beamLoadDrawing1 = `data:image/jpg;base64,${drawing}`;
    });
  }

  getCompositeBeamRequestObject = (width: number, height: number, numberOfRows: number, connectorsSpacing?: number): models.CompositeBeamDrawing => {
    /*** @TODO: remove this after CTICM fix Infinity issue ***/
    if (!isFinite(connectorsSpacing)) {
      connectorsSpacing = 0;
    }
    const sp: models.CompositeBeamDrawing = {
      'beamGeometry': this.getBeamGeometryObject(false),  // This drawing will be in millimeters hence need to convert
      'concreteSlab': this.getConcreteSlabObject(true), // //This drawing will be in millimeters hence no need to convert
      // This drawing will be in millimeters hence no need to convert
      'profileSheeting': this.subProjectForm.value.slabType.value === 1 ? this.getProfileSheetingObject(true) : {},
      'shearConnector': this.getShearConnectorObject(),
      // This drawing will be in millimeters hence no need to convert
      'steelProfile': this.getSteelProfileObject(true),
      'pictureWidth': +width,
      'pictureHeight': +height,
      'numberOfRows': numberOfRows,
      'connectorsSpacing': connectorsSpacing ? connectorsSpacing : 0,
      'showSymbol': true,
      'lengthUnit': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? 2 : 1,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };
    return sp;
  }

  getConnectionZonesRequestObject = (result: models.Calculate.ShearConnectionResult, width: number, height: number): models.Calculate.ConnectionZonesDrawing => {
    const sp: models.Calculate.ConnectionZonesDrawing = {
      'beamGeometry': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? this.getBeamGeometryObject(true) : this.getBeamGeometryObject(false),
      'concreteSlab': this.getConcreteSlabObject(true), // //This drawing will be in millimeters hence no need to convert
      // This drawing will be in millimeters hence no need to convert
      'profileSheeting': this.subProjectForm.value.slabType.value === 1 ? this.getProfileSheetingObject(true) : {},
      // This drawing will be in millimeters hence no need to convert
      'steelProfile': this.getSteelProfileObject(true),
      'shearConnectionResult': result,
      'pictureWidth': +width,
      'pictureHeight': +height,
      'lengthUnit': this.dropDownOptions.lengthUnits.find(lu => lu.id === this.project.lengthUnit).value,
      'showSymbol': true,
      'language': this.user.defaultSettings.language,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)

    };
    return sp;
  }

  getObservableCompositeBeamDrawing = (width: number, height: number, numberOfRows, connectorsSpacing): Observable<any> => {
    if (!this.isValidCompositeDrawing()) {
      this.compositeBeamDrawing = '';
      return;
    }
    const sp = this.getCompositeBeamRequestObject(width, height, numberOfRows, connectorsSpacing);

    return this.calculationsService.getCompositeBeamDrawing(sp);
  }

  getCompositeBeamDrawing = (width: number, height: number, numberOfRows: number): void => {
    if (!this.isValidCompositeDrawing()) {
      this.compositeBeamDrawing = '';
      return;
    }
    const sp = this.getCompositeBeamRequestObject(width, height, numberOfRows);

    this.calculationsService.getCompositeBeamDrawing(sp).subscribe(drawing => {
      this.compositeBeamDrawing = `data:image/jpg;base64,${drawing}`;
    });
  }

  getObservableConnectionZonesDrawing = (result: models.Calculate.ShearConnectionResult, width: number, height: number): Observable<any> => {
    const sp = this.getConnectionZonesRequestObject(result, width, height);
    return this.calculationsService.getConnectionZonesDrawing(sp);
  }

  transformLoadsForSave = (load: models.Loads): models.Loads => {
    const loads = _.cloneDeep(load);
    for (let i = 0; i < loads.loadCases.length; i++) {
      loads.loadCases[i].distributedSurfaceLoad = UnitHelper.roundLoadToDb(loads.loadCases[i].distributedSurfaceLoad, this.project.loadUnit);
      loads.loadCases[i].combinationFactor = this.subProjectForm.value.combinationFactor;
      for (let j = 0; j < loads.loadCases[i].pointLoads.length; j++) {
        loads.loadCases[i].pointLoads[j].location = loads.loadCases[i].pointLoads[j].location;
        loads.loadCases[i].pointLoads[j].value = UnitHelper.roundLoadToDb(loads.loadCases[i].pointLoads[j].value, this.project.loadUnit);
      }
      for (let k = 0; k < loads.loadCases[i].lineLoads.length; k++) {
        loads.loadCases[i].lineLoads[k].originLoad.value = UnitHelper.roundLoadToDb(loads.loadCases[i].lineLoads[k].originLoad.value, this.project.loadUnit);
        loads.loadCases[i].lineLoads[k].endLoad.value = UnitHelper.roundLoadToDb(loads.loadCases[i].lineLoads[k].endLoad.value, this.project.loadUnit);
        loads.loadCases[i].lineLoads[k].originLoad.location = loads.loadCases[i].lineLoads[k].originLoad.location;
        loads.loadCases[i].lineLoads[k].endLoad.location = loads.loadCases[i].lineLoads[k].endLoad.location;
      }
    }
    if (loads.userCompositeSelfWeight) {
      loads.userCompositeSelfWeight = UnitHelper.roundLoadToDb(loads.userCompositeSelfWeight, this.project.loadUnit);
    } else {
      loads.userCompositeSelfWeight = 0;
    }
    return loads;
  }

  transformLoadsForCalculations = (load: models.Loads, isForDrawing = false): models.Loads => {
    const loads = _.cloneDeep(load);
    for (let i = 0; i < loads.loadCases.length; i++) {
      if (isForDrawing) {
        loads.loadCases[i].distributedSurfaceLoad = UnitHelper.roundPatchLoad(loads.loadCases[i].distributedSurfaceLoad, this.project.loadUnit);
      } else {
        loads.loadCases[i].distributedSurfaceLoad = UnitHelper.roundLoadToApi(loads.loadCases[i].distributedSurfaceLoad, this.project.loadUnit);
      }
      loads.loadCases[i].combinationFactor = this.subProjectForm.value.combinationFactor;
      for (let j = 0; j < loads.loadCases[i].pointLoads.length; j++) {
        loads.loadCases[i].pointLoads[j].location = this.project.unit === 1 ? loads.loadCases[i].pointLoads[j].location :
          UnitHelper.ftToInches(loads.loadCases[i].pointLoads[j].location);

        //  loads.loadCases[i].pointLoads[j].value = this.project.designCode === 2 ? loads.loadCases[i].pointLoads[j].value :
        //                  UnitHelper.roundLoadToApi(loads.loadCases[i].pointLoads[j].value, this.project.unit);
        loads.loadCases[i].pointLoads[j].value = UnitHelper.roundPointLoad(loads.loadCases[i].pointLoads[j].value, this.project.loadUnit);
      }
      for (let k = 0; k < loads.loadCases[i].lineLoads.length; k++) {
        loads.loadCases[i].lineLoads[k].originLoad.value = UnitHelper.roundPatchLoad(loads.loadCases[i].lineLoads[k].originLoad.value, this.project.loadUnit);
        loads.loadCases[i].lineLoads[k].endLoad.value = UnitHelper.roundPatchLoad(loads.loadCases[i].lineLoads[k].endLoad.value, this.project.loadUnit);
        loads.loadCases[i].lineLoads[k].originLoad.location = this.project.unit === 1 ? loads.loadCases[i].lineLoads[k].originLoad.location :
          UnitHelper.ftToInches(loads.loadCases[i].lineLoads[k].originLoad.location);
        loads.loadCases[i].lineLoads[k].endLoad.location = this.project.unit === 1 ? loads.loadCases[i].lineLoads[k].endLoad.location :
          UnitHelper.ftToInches(loads.loadCases[i].lineLoads[k].endLoad.location);
      }
    }
    if (loads.userCompositeSelfWeight) {
      loads.userCompositeSelfWeight = UnitHelper.roundLoadToApi(loads.userCompositeSelfWeight, this.project.loadUnit);
    } else {
      loads.userCompositeSelfWeight = 0;
    }
    return loads;
  }

  handleDxfError = () => {
    this.sharedService.popFailure('subproject-generate-dxf-failure');
  }

  handleBOMError = () => {
    this.sharedService.popFailure('subproject-generate-bom-failure');
  }

  exportDxf = () => {
    if (!this.calculationResponse || !this.calculationResponse.designCriteriaOk) {
      this.handleDxfError();
      return;
    }

    const dxfDrawing = {
      'beamGeometry': this.getBeamGeometryObject(true),
      'concreteSlab': this.getConcreteSlabObject(true),
      'profileSheeting': this.getProfileSheetingObject(true),
      'shearConnector': this.getShearConnectorObject(),
      'steelProfile': this.getSteelProfileObject(true),
      'shearConnectionResult': this.calculationResponse.shearConnectionResult,
      'lengthUnit': this.dropDownOptions.lengthUnits.find(lu => lu.id === this.project.lengthUnit).value,
      'language': this.user.defaultSettings.language
    };

    this.calculationsService.getDxf(dxfDrawing)
      .subscribe((data) => {
        if (data.drawingSuccessful) {
          const dxfData = new Blob([data.drawing], { type: 'text/plain;charset=ASCII' });
          const filename = this.subProjectForm.value.subprojectName + '_' + (new Date).toISOString() + '.dxf';
          FileSaver.saveAs(dxfData, filename);
        } else {
          console.log('Error Generating DXF');
          this.handleDxfError();
        }
      }
        , error => {
          console.log('Error generating DXF file');
          this.handleDxfError();
        }, () => {
        });
  }

  displayAdditionalLoad = () => {
    this.hideAdditionalLoad = false;
    this.tabstripComponent.selectTab(SubProjectComponent.ADDITIONAL_LOADS);
  }

  getBOM = () => {
    if (!this.calculationResponse || !this.calculationResponse.designCriteriaOk) {
      this.handleBOMError();
      return;
    }

    const bomInput = {
      'version': this.appVersion,
      'language': this.user.defaultSettings.language,
      'generalInformation': this.getGeneralInformation(),
      'shearConnector': this.getShearConnectorObject(),
      'shearConnectionResult': this.calculationResponse.shearConnectionResult,
      'numberOfConnectors': this.calculationResponse.shearConnectionResult.numberOfConnectors,
      'connectorType': +(<any>this.subProjectForm).controls.shearConnectionType.value.value,
      'optimizationOption': +!(<any>this.subProjectForm).controls.optimizationOption.value
    };

    this.calculationsService.getBillOfMaterials(bomInput)
      .subscribe((data) => {
        if (data.pdfStream) {
          const blob = this.b64toBlob(data.pdfStream, 'application/pdf');
          const filename = this.subProjectForm.value.subprojectName + '_' + (new Date).toISOString() + '.pdf';
          FileSaver.saveAs(blob, filename);
        } else {
          console.log('Error Generating Bill Of Materials');
          this.handleBOMError();
        }
      }
        , error => {
          console.log('Error Generating Bill Of Materials');
          this.handleBOMError();
        }, () => {
        });
  }

  getGeneralInformation = (): models.Calculate.GeneralInformation => {
    const options = { hour12: false };
    const dateString = new Date().toLocaleString(window.navigator.language, options);
    return {
      'userName': this.project.preparedBy,
      'projectName': this.project.name || '',
      'companyName': this.project.company || '',
      'companyAddress': this.getFormattedAddress(), // TODO: make it more polished
      'projectReferences': this.project.reference || '',
      'nationalAnnexValue': +this.nationalAnnexes.filter(item => item.id === this.project.countryNationalAnnexes)[0].value,
      'loadedAreasCategory': +this.loadCategories.filter(item => item.id === this.subProjectForm.value.loadCategory.id)[0].value,
      'scopeExtensions': this.getScopeExtensions(),
      'phoneFax': this.project.phone || '',
      'website': '',
      'comments': this.project.comments || '',
      'email': this.project.email || '',
      'contractor': this.project.contractor || '',
      'subProject': this.subProjectForm.value.subprojectName || '',
      'date': dateString,
      'standard': this.getStandardValue(this.project.designCode),
      'unit': this.getUnitSystemValue(this.project.unit),
      'liveLoadReduction': this.subProjectForm.value.liveLoadReduction
    };
  }

  getScopeExtensions = (): models.Calculate.ScopeExtensions => {
    const isScopeExtensionsActivated = this.subProjectForm.value.slabType.value === 1 // Composite slab with profiled steel sheeting
      && this.subProjectForm.value.profiledSheetingOrientation.id === 1 // Profiled steel sheeting is perpendicular to the beam
      && (this.subProjectForm.value.profiledSheetingType.id === 58 // HI BOND A 55
        || (this.subProjectForm.value.profiledSheetingType.id >= 33 && this.subProjectForm.value.profiledSheetingType.id <= 40) // HI BOND 55
        || (this.subProjectForm.value.profiledSheetingType.id >= 139 && this.subProjectForm.value.profiledSheetingType.id <= 145)) // Sand 55
      ? true : false;

    const scopeExtensions: models.Calculate.ScopeExtensions = {
      extension1: isScopeExtensionsActivated,
      extension2: isScopeExtensionsActivated
    };
    return scopeExtensions;
  }

  getLoadDrawing = (index: number): void => {
    /* Handle zero loads*/
    if (index === 0 && this.subProjectModel.load.loadCases[0].distributedSurfaceLoad === 0) {
      this.standardLoadDrawing0 = '';
      return;
    }

    if (index === 2 && this.subProjectModel.load.loadCases[2].distributedSurfaceLoad === 0) {
      this.standardLoadDrawing2 = '';
      return;
    }
    if (index === 3 && this.subProjectModel.load.loadCases[3].distributedSurfaceLoad === 0) {
      this.surfaceLiveLoadsDrawing = '';
      return;
    }
    const sp: models.LoadDrawing = this.getLoadsModel(models.Calculate.LoadDrawingType.SIMPLE_LOADS, index);
    if (index === 3) {
      sp.pictureWidth = SubProjectComponent.ADDITIONAL_LOAD_DRAWING_WIDTH;
    }
    ;
    this.calculationsService.getLoadDrawing(sp).subscribe(drawing => {
      if (index === 0) {
        this.standardLoadDrawing0 = drawing ? `data:image/jpg;base64,${drawing}` : '';
      }
      if (index === 1) {
        this.standardLoadDrawing1 = drawing ? `data:image/jpg;base64,${drawing}` : '';
      }
      if (index === 2) {
        this.standardLoadDrawing2 = drawing ? `data:image/jpg;base64,${drawing}` : '';
      }
      if (index === 3) {
        this.surfaceLiveLoadsDrawing = drawing ? `data:image/jpg;base64,${drawing}` : '';
      }
    });
  }

  getLoadsModel = (type: models.Calculate.LoadDrawingType, index: number, isForDrawing = false): models.LoadDrawing => {
    const sp: models.LoadDrawing = {
      'beamGeometry': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? this.getBeamGeometryObject(true) : this.getBeamGeometryObject(false),
      'concreteSlab': this.getConcreteSlabObject(true),
      'steelProfile': this.getSteelProfileObject(true),
      'loads': this.transformLoadsForCalculations(this.subProjectModel.load, isForDrawing),
      'loadCaseIndex': index,
      'pictureWidth': SubProjectComponent.LOAD_DRAWING_WIDTH,
      'pictureHeight': SubProjectComponent.LOAD_DRAWING_HEIGHT,
      'showSymbol': true,
      'lengthUnit': this.dropDownOptions.lengthUnits.find(lu => lu.id === this.project.lengthUnit).value,
      'forceUnit': this.dropDownOptions.loadUnits.find(lu => lu.id === this.project.loadUnit).value,
      'type': type,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.getStandardValue(this.project.designCode)
    };
    return sp;
  }

  getLiveLineLoadsDrawing = (): void => {
    if (this.subProjectModel.load.loadCases[3].lineLoads.length > 0) {
      const sp: models.LoadDrawing = this.getLoadsModel(models.Calculate.LoadDrawingType.LINE_LOADS, 3);
      sp.pictureWidth = SubProjectComponent.ADDITIONAL_LOAD_DRAWING_WIDTH;
      this.calculationsService.getLoadDrawing(sp).subscribe(drawing => {
        this.liveLineLoadsDrawing = drawing ? `data:image/jpg;base64,${drawing}` : '';
      });
    } else {
      this.liveLineLoadsDrawing = '';
    }
  }

  getDeadLineLoadsDrawing = (): void => {
    if (this.subProjectModel.load.loadCases[1].lineLoads.length > 0) {
      const sp: models.LoadDrawing = this.getLoadsModel(models.Calculate.LoadDrawingType.LINE_LOADS, 1);
      sp.pictureWidth = SubProjectComponent.ADDITIONAL_LOAD_DRAWING_WIDTH;
      this.calculationsService.getLoadDrawing(sp).subscribe(drawing => {
        this.deadLineLoadsDrawing = drawing ? `data:image/jpg;base64,${drawing}` : '';
      });
    } else {
      this.deadLineLoadsDrawing = '';
    }
  }

  getLivePointLoadsDrawing = (): void => {
    if (this.subProjectModel.load.loadCases[3].pointLoads.length > 0) {
      const sp: models.LoadDrawing = this.getLoadsModel(models.Calculate.LoadDrawingType.POINT_LOADS, 3);
      sp.pictureWidth = SubProjectComponent.ADDITIONAL_LOAD_DRAWING_WIDTH;
      this.calculationsService.getLoadDrawing(sp).subscribe(drawing => {
        this.livePointLoadsDrawing = drawing ? `data:image/jpg;base64,${drawing}` : '';
      });
    } else {
      this.livePointLoadsDrawing = '';
    }
  }

  getDeadPointLoadsDrawing = (): void => {
    if (this.subProjectModel.load.loadCases[1].pointLoads.length > 0) {
      const sp: models.LoadDrawing = this.getLoadsModel(models.Calculate.LoadDrawingType.POINT_LOADS, 1, true);
      sp.pictureWidth = SubProjectComponent.ADDITIONAL_LOAD_DRAWING_WIDTH;
      this.calculationsService.getLoadDrawing(sp).subscribe(drawing => {
        this.deadPointLoadsDrawing = drawing ? `data:image/jpg;base64,${drawing}` : '';
      });
    } else {
      this.deadPointLoadsDrawing = '';
    }
  }

  getCompositeWeightObject = (): any => {
    return {
      'beamGeometry': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? this.getBeamGeometryObject(true) : this.getBeamGeometryObject(false),
      'steelProfile': this.getSteelProfileObject(true),
      'concreteSlab': this.getConcreteSlabObject(true),
      'profileSheeting': this.getProfileSheetingObject(true),
      'unitSystem': this.getUnitSystemValue(this.project.unit)
    };
  }

  getStandardLoadDrawings = (): void => {
    this.getLoadDrawing(0);
    this.getLoadDrawing(1);
    this.getLoadDrawing(2);
    this.getBeamLoadDrawing(SubProjectComponent.LOAD_DRAWING_WIDTH, SubProjectComponent.LOAD_DRAWING_HEIGHT);
  }

  getObservableDefaultCompositeSelfWeight = (): Observable<any> => {
    const compositeSelfWeight: models.CompositeSelfWeight = this.getCompositeWeightObject();
    return this.calculationsService.getCompositeSelfWeight(compositeSelfWeight);
  }

  getObservableDefaultLiveLoad = (): Observable<any> => {
    const defaultCompositeLiveLoad: models.DefaultCompositeLiveLoad = {
      'generalInformation': this.getGeneralInformation(),
      'beamGeometry': this.project.unit === AppConstants.UNIT_SYSTEM_MI ? this.getBeamGeometryObject(true) : this.getBeamGeometryObject(false)
    };
    return this.calculationsService.getdefaultCompositeLiveLoad(defaultCompositeLiveLoad);
  }

  isFormValid = (): void => {
    this.isFormValidSubject.next();
  }

  isTabInvalid = (tabName: string): boolean => {
    // console.log('isTabInvalid: ' + tabName);
    const tabControls = this.formInputElements.filter((inputElem) =>
      inputElem.nativeElement.getAttribute('tab') === tabName &&
      (<any>this.subProjectForm).controls[inputElem.nativeElement.getAttribute('formControlName')].invalid);
    // tabControls.forEach(tabControl=> console.log('isTabInvalid control: ' + tabControl.nativeElement.getAttribute('formControlName')));
    return tabControls.length > 0;
  }


  debouncedIsFormValid = () => {
    _.forEach(this.subProjectForm.controls, (control) => {
      control.markAsTouched();
    });
    const controls = this.subProjectForm.controls;
    const firstInvalidFormName = _.find(_.keys(this.subProjectForm.controls), (propName) => {
      return (<any>controls)[propName].invalid;
    });
  }

  private getReportData = (): models.Calculate.CreateCommand => {
    const currentDate = new Date();
    const calcInput = <models.Calculate.CreateCommand>{
      'id': this.subProjectModel.id,
      'projectId': this.subProjectModel.projectId,
      'name': this.subProjectForm.value.subprojectName || '',
      'version': this.appVersion,
      'beamGeometry': this.project.unit === 1 ? this.getBeamGeometryObject(true) : this.getBeamGeometryObject(false),
      'concreteSlab': this.getConcreteSlabObject(true),
      'profileSheeting': this.getProfileSheetingObject(true),
      'shearConnector': this.getShearConnectorObject(),
      'steelProfile': this.getSteelProfileObject(true),
      'reInforcementSteelBars': {
        'steelGradeValue': +this.subProjectForm.value.reinforcementType.value
      },
      'loads': this.transformLoadsForCalculations(this.subProjectModel.load),
      'deformations': {
        'constructionTypeValue': +this.subProjectForm.value.constructionType.value,
        'precamber': this.subProjectForm.value.precamber ? UnitHelper.roundToUniverseLength(this.subProjectForm.value.precamber, this.project.unit, this.project.unit) : 0,
        // tslint:disable-next-line:max-line-length
        'totalDeflectionLimit': (this.subProjectForm.value.totalLoadDeflection ? +this.subProjectForm.value.totalLoadDeflection.value : 0),
        'compositeDeflectionLimit': (this.subProjectForm.value.deflectionLimit ? +this.subProjectForm.value.deflectionLimit.value : 0),
        'percentageLiveLoad': (this.subProjectForm.value.liveLoadPercentage ? +this.subProjectForm.value.liveLoadPercentage.value : 0),
        'frequencyLimit': this.subProjectForm.value.frequencyLimit,
        'walkingActivity': this.subProjectForm.value.walkingActivity.value,
        'dampingRatio': this.subProjectForm.value.dampling ? this.subProjectForm.value.dampling.value : 0,
        'walkingExcitationCheck': +this.subProjectForm.value.walkingExcitation,
        'rhythmicExcitationCheck': +this.subProjectForm.value.rhythmicExcitationCheck,
        'rhythmicActivity': this.subProjectForm.getRawValue().rhythmicActivity.value,
        'incrementalDeflectionCheck': (this.subProjectForm.getRawValue().incrementalDeflectionCheck ? this.subProjectForm.value.incrementalDeflectionCheck : 0),
        'permanentLoadFraction': (this.subProjectForm.getRawValue().permanentLoadFraction ? +this.subProjectForm.getRawValue().permanentLoadFraction : 0),
        'performLateralTorsionBucklingCheck': this.subProjectForm.value.performLateralTorsionBucklingCheck,
      },
      partialFactors: {
        'gammaC': +this.partialFactor.gammaC,
        'gammaG': +this.partialFactor.gammaG,
        'gammaM0': +this.partialFactor.gammaM0,
        'gammaM1': +this.partialFactor.gammaM1,
        'gammaQ': +this.partialFactor.gammaQ,
        'gammaS': +this.partialFactor.gammaS,
        'gammaV': +this.partialFactor.gammaV,
        'gammaP': +this.partialFactor.gammaP,
        'USDeadLoad1': +this.project.usDeadLoad1,
        'USDeadLoad2': +this.project.usDeadLoad2,
        'USLiveLoad2': +this.project.usLiveLoad2,
        'USPhiElastic': +this.project.usPhiElastic,
        'combinationFactor': +this.subProjectForm.value.combinationFactor,
        'asPhiC': +this.partialFactor.asPhiC,
        'asPhiM': +this.partialFactor.asPhiM,
        'asPhiMb': +this.partialFactor.asPhiMb,
        'asPhiS': +this.partialFactor.asPhiS,
        'asPhiSC': +this.partialFactor.asPhiSC,
        'asPhiSR': +this.partialFactor.asPhiSR,
        'asPhiVc': +this.partialFactor.asPhiVc,
        'asPhiVf': +this.partialFactor.asPhiVf,
        'asPhiVM': +this.partialFactor.asPhiVm
      },
      'generalInformation': this.getGeneralInformation(),
      'language': this.user.defaultSettings.language,
      'lengthUnit': this.dropDownOptions.lengthUnits.find(lu => lu.id === this.project.lengthUnit).value,
      'forceUnit': this.dropDownOptions.loadUnits.find(lu => lu.id === this.project.loadUnit).value,
      'unitSystem': this.getUnitSystemValue(this.project.unit),
      'designCode': this.project.designCode,
      'detailedSheet': this.getDetailedSheetValue()
    };
    return calcInput;
  }

  private getDetailedSheetValue(): boolean {
    const na = this.nationalAnnexes.find(item => item.id === this.project.countryNationalAnnexes);
    if (na.countryCode === 'AE' && na.designCodeId === 2) {
      return true;
    }
    return false;
  }
  private generateReport = (): void => {
    this.isFormValid();

    // Calculate the loads to make sure they are all in sync with the parameters selected
    const o1 = this.getObservableDefaultCompositeSelfWeight();
    const o2 = this.getObservableDefaultLiveLoad();
    const combine = observableZip(o1, o2);
    const subscribe = combine.subscribe((defaultLoads: any) => {
      // console.log('Calculate default loads result ', defaultLoads);
      if (defaultLoads && defaultLoads.length !== 0) {
        this.resetDefaultLoadsOnForm(defaultLoads, false);
      }
      const reportData = this.getReportData();
      this.sharedService.showLoader(true);
      this.calculationsService.getReport(reportData).subscribe(result => {
        if (result.pdfStream !== null) {
          this.sharedService.showLoader(false);
          const byteArray = result.pdfStream;
          const filename = this.subProjectForm.value.subprojectName + '_' + (new Date).toISOString() + '_report.pdf';
          if (this.isIEOrEdge()) {
            const blob = this.b64toBlob(byteArray, 'pdf');
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else if (this.isMobile()) {
            this.sessionStorageService.set('pdf', byteArray);
            this.router.navigate(['/report',
              {
                projectId: this.projectId, projectName: this.project.name,
                subProjectId: this.subProjectId, subProjectName: reportData.generalInformation.subProject
              }]);
          } else {
            if (this.isChrome()) {
              const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
              const version = raw ? parseInt(raw[2], 10) : false;
              if (version >= 60) {
                const chromeBlob = this.b64toBlob(byteArray, 'application/pdf');
                FileSaver.saveAs(chromeBlob, filename);
              } else {
                window.open('data:application/pdf;base64, ' + byteArray, '_blank', 'toolbar=no, menubar=no, location=no, addressbar=no');
              }
            } else {
              window.open('data:application/pdf;base64, ' + byteArray, '_blank', 'toolbar=no, menubar=no, location=no, addressbar=no');
            }
          }
        }
        this.sharedService.showLoader(false);
      }, error => {
        console.log('Error Generating Report');
        this.sharedService.popFailure('subproject-generate-report-failure');
        this.sharedService.showLoader(false);
      }, () => {
        this.sharedService.showLoader(false);
      });
    }, error => {
      console.log('Error Getting Default Loads');
    }, () => {
    });
  }

  b64toBlob(b64Data, contentType?, sliceSize?) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  isChrome(): boolean {
    if (/Chrome\/\d./i.test(navigator.userAgent)) {
      // This is Chrome Browser
      return true;
    }
  }

  isIEOrEdge(): boolean {
    if (/MSIE 10/i.test(navigator.userAgent)) {
      // This is internet explorer 10
      return true;
    }

    if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
      // This is internet explorer 9 or 11
      return true;
    }

    if (/Edge\/\d./i.test(navigator.userAgent)) {
      // This is Microsoft Edge
      return true;
    }
  }

  isMobile(): boolean {
    let check = false;
    // tslint:disable-next-line
    ((a) => { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || (<any>window).opera);
    return check;
  }

  getValue = (value) => {
    return value ? value : '';
  }

  getFormattedAddress = (): string => {
    if (this.project.address1 || this.project.address2 || this.project.city || this.project.stateProvince || this.project.postalCode) {
      return this.getValue(this.project.address1) + this.getValue(this.project.address2) +
        this.getValue(this.project.city) + this.getValue(this.project.stateProvince) + this.getValue(this.project.postalCode)
        + this.getValue(this.project.country);
    }
    return '';
  }

  initializeDropDownSelectedObjects = (): any => {
    return null;
  }

  customProfileSheetingTroughValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm ||
        !(<any>this.subProjectForm).controls ||
        !(<any>this.subProjectForm).controls.profiledSheetingType ||
        !(<any>this.subProjectForm).controls.profiledSheetingType.value ||
        (<any>this.subProjectForm).controls.profiledSheetingType.value.label !== 'Custom' ||
        this.subProjectForm.value.slabType.value === 0) {
        return null;
      }
      const trough = <any>+control.value;
      const topWidth = <any>+this.subProjectForm.value.profiledSheetingCustomTopWidth;
      const bottomWidth = <any>+this.subProjectForm.value.profiledSheetingCustomBottomWidth;
      let isInvalid = false;
      if (trough >= topWidth && trough >= bottomWidth) {
        isInvalid = false;
      } else {
        isInvalid = true;
      }

      return isInvalid ? { customRange: { valid: false } } : null;
    };
  }

  customProfiledSheetingBottomValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm ||
        !(<any>this.subProjectForm).controls ||
        !(<any>this.subProjectForm).controls.profiledSheetingType ||
        !(<any>this.subProjectForm).controls.profiledSheetingType.value ||
        (<any>this.subProjectForm).controls.profiledSheetingType.value.label !== 'Custom' ||
        this.subProjectForm.value.slabType.value === 0) {
        return null;
      }
      const bottomWidth = <any>+control.value;
      const stiffenerWidth = <any>+this.subProjectForm.value.profiledSheetingCustomRibStiffenerWidth;
      const stiffenerSpacing = <any>+this.subProjectForm.value.profiledSheetingCustomStiffenersSpacing;
      let isInvalid = false;
      if (bottomWidth >= 2 * stiffenerWidth + stiffenerSpacing) {
        isInvalid = false;
      } else {
        isInvalid = true;
      }

      return isInvalid ? { customRange: { valid: false } } : null;
    };
  }

  customFlangeWidthValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm ||
        !(<any>this.subProjectForm).controls.profileType ||
        !(<any>this.subProjectForm).controls.profileType.value ||
        (<any>this.subProjectForm).controls.profileType.value.profileRange !== 'Custom') {
        return null;
      }
      const flangeWidth = <any>+control.value;
      const rootRadius = <any>+this.subProjectForm.value.steelProfileCustomRootRadius;
      const webThickness = <any>+this.subProjectForm.value.steelProfileCustomWebThickness;
      let isInvalid = false;
      if (flangeWidth <= (2 * rootRadius) + webThickness) {
        isInvalid = true;
      }

      return isInvalid ? { customRange: { valid: false } } : null;
    };
  }

  conditionalCustomProfiledSheetingValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (this.subProjectForm.value.slabType && this.subProjectForm.value.slabType.value === 0) {
        if (!control.value) {
          return { required: true };
        }
      }
      return null;
    };
  }

  customSectionHeightValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm ||
        !(<any>this.subProjectForm).controls.profileType ||
        !(<any>this.subProjectForm).controls.profileType.value ||
        (<any>this.subProjectForm).controls.profileType.value.profileRange !== 'Custom') {
        return null;
      }
      const sectionHeight = <any>+control.value;
      const rootRadius = <any>+this.subProjectForm.value.steelProfileCustomRootRadius;
      const flangeThickness = <any>+this.subProjectForm.value.steelProfileCustomFlangeThickness;
      let isInvalid = false;
      if (sectionHeight <= (2 * rootRadius) + (2 * flangeThickness)) {
        isInvalid = true;
      }

      return isInvalid ? { customRange: { valid: false } } : null;
    };
  }

  slabConnectorValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm) {
        return null;
      }
      const shearConnectorType = control.value;
      const haunchHeight = <any>+this.subProjectForm.value.haunchHeight;
      const thickness = <any>+this.subProjectForm.value.slabThickness;
      const coverRequired = <any>this.subProjectForm.value.coverRequired === true;
      return this.slabThicknessValidations(thickness, haunchHeight, coverRequired, shearConnectorType);
    };
  }

  beamLeftSpacingValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      let isValid;
      if (!this.subProjectForm) {
        return null;
      }
      const beamSpacing = <any>+control.value;
      isValid = beamSpacing >= this.validationValues.beamSpacingLeft.min && beamSpacing <= this.validationValues.beamSpacingLeft.max;
      if (isValid) {
        return null;
      } else {
        return { validateBeamSpacing: false };
      }
    };
  }

  beamRightSpacingValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      let isValid;
      const beamSpacing = <any>+control.value;
      isValid = beamSpacing >= this.validationValues.beamSpacingRight.min && beamSpacing <= this.validationValues.beamSpacingRight.max;
      if (isValid) {
        return null;
      } else {
        return { validateBeamSpacing: false };
      }
    };
  }

  leftOpeningPositionValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      let isValid;
      if (!this.subProjectForm) {
        return null;
      }
      const leftOpening = this.subProjectForm.get('leftOpening').value;
      if (!leftOpening) {
        return null;
      }

      const leftOpeningPosition = <any>+control.value;
      const leftSpacing = <any>+this.subProjectForm.value.beamSpacingLeft;
      isValid = leftOpeningPosition > 0 && leftOpeningPosition < leftSpacing;
      if (isValid) {
        return null;
      } else {
        return { validateLeftOpeningPosition: false };
      }
    };
  }

  rightOpeningPositionValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      let isValid;
      if (!this.subProjectForm) {
        return null;
      }

      const rightOpening = this.subProjectForm.get('rightOpening').value;
      if (!rightOpening) {
        return null;
      }
      const rightOpeningPosition = <any>+control.value;
      const rightSpacing = <any>+this.subProjectForm.value.beamSpacingRight;
      isValid = rightOpeningPosition > 0 && rightOpeningPosition < rightSpacing;
      if (isValid) {
        return null;
      } else {
        return { validateRightOpeningPosition: false };
      }
    };
  }

  concreteStrengthUSValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      let isValid;
      if (!this.subProjectForm) {
        return null;
      }
      if (this.project.designCode === 1 && this.subProjectForm.value.concreteClass.label !== 'Custom'
        || !this.subProjectForm.value.concreteType) {
        return null;
      }

      const concreteStrengthUS = <any>+control.value;
      const concreteTypeId = <any>+this.subProjectForm.value.concreteType.id;
      isValid = concreteStrengthUS >= this.validationValues.customDefinedConcreteRange.min
        && concreteStrengthUS <= this.validationValues.customDefinedConcreteRange.max;

      if (isValid) {
        return null;
      } else {
        return { validateRightOpeningPosition: false };
      }
    };
  }

  subProjectNameValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm || !_.isArray(this.subProjects)) {
        return null;
      }
      const foundIndex = _.findIndex(this.subProjects, (subProject) => {
        return (<any>subProject).name.toLowerCase() === control.value.toLowerCase() && (<any>subProject).id !== this.subProjectId;
      });
      return foundIndex >= 0 ? { notUniqueName: { valid: false } } : null;
    };
  }

  isSaveAsSubProjectNameUnique = (subProjectName: string): boolean => {
    if (_.isArray(this.subProjects)) {

      const foundIndex = _.findIndex(this.subProjects, (subProject) => {
        return (<any>subProject).name.toLowerCase() === subProjectName.toLowerCase();
      });
      if (foundIndex >= 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  coverRequiredValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm || !this.subProjectForm.value.shearConnectionType) {
        return null;
      }
      const coverRequired = control.value === true;
      const haunchHeight = this.subProjectForm.value.haunchHeight;
      const thickness = this.subProjectForm.value.slabThickness;
      const shearConnectorType = this.shearConnectorTypes.filter((item) => item.id === this.subProjectForm.value.shearConnectionType.id)[0];
      return this.slabThicknessValidations(thickness, haunchHeight, coverRequired, shearConnectorType);
    };
  }

  haunchHeightValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm || !this.subProjectForm.value.shearConnectionType) {
        return null;
      }
      const haunchHeight = <any>+control.value;
      const thickness = +this.subProjectForm.value.slabThickness;
      const coverRequired = this.subProjectForm.value.coverRequired === true;
      const shearConnectorType = this.shearConnectorTypes.filter((item) => item.id === this.subProjectForm.value.shearConnectionType.id)[0];
      return this.slabThicknessValidations(thickness, haunchHeight, coverRequired, shearConnectorType);
    };
  }

  slabThicknessValidations = (thickness: number, haunchHeight: number,
    coverRequired: boolean, shearConnectorType: any): { [key: string]: any } => {
    let isInvalid = false;
    if (!shearConnectorType) {
      isInvalid = true;
    } else if (coverRequired && (thickness + haunchHeight) < (this.project.unit === 1 ?
      shearConnectorType.minSlabThicknessWithCorrosion : UnitHelper.convertMMToInch(shearConnectorType.minSlabThicknessWithCorrosion))) {
      isInvalid = true;
    } else if (!coverRequired && (thickness + haunchHeight) < (this.project.unit === 1 ?
      shearConnectorType.minSlabThicknessWithOutCorrosion : UnitHelper.convertMMToInch(shearConnectorType.minSlabThicknessWithOutCorrosion))) {
      isInvalid = true;
    }
    if (isInvalid) {
      (<any>this.subProjectForm).controls.slabThickness.setErrors({ slabThicknessConnectorType: { valid: false } });
      (<any>this.subProjectForm).controls.coverRequired.setErrors({ slabThicknessConnectorType: { valid: false } });
    } else {
      (<any>this.subProjectForm).controls.coverRequired.setErrors(null);
      (<any>this.subProjectForm).controls.slabThickness.setErrors(null);
    }
    return isInvalid ? { slabThicknessConnectorType: { valid: false } } : null;
  }

  clearAllErrors = () => {
    _.forEach(this.subProjectForm.controls, (control) => {
      control.setErrors(null);
    });
  }

  setCustomSteelProfileValidators() {
    // tslint:disable-next-line:max-line-length
    if (this.subProjectForm && this.subProjectForm.controls.profileType.value && this.subProjectForm.controls.profileType.value.profileRange === 'Custom') {
      this.subProjectForm.get('steelProfileCustomHeight').setValidators([Validators.required, CustomValidators.range([this.validationValues.steelProfileCustomHeight.min, this.validationValues.steelProfileCustomHeight.max]), this.customSectionHeightValidator()]);
      // tslint:disable-next-line:max-line-length
      this.subProjectForm.get('steelProfileCustomRootRadius').setValidators([Validators.required, CustomValidators.range([this.validationValues.steelProfileCustomRootRadius.min, this.validationValues.steelProfileCustomRootRadius.max])]);
    } else {
      this.subProjectForm.get('steelProfileCustomHeight').setValidators([]);
      this.subProjectForm.get('steelProfileCustomRootRadius').setValidators([]);
    }
  }

  orientationValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.subProjectForm) {
        return null;
      }
      const isInvalid = false;
      // solid slab value = 0

      if (isInvalid) {
        (<any>this.subProjectForm).controls.profiledSheetingOrientation.setErrors({ orientationMismatch: { valid: false } });
        (<any>this.subProjectForm).controls.shearConnectionOrientation.setErrors({ orientationMismatch: { valid: false } });
      } else {
        (<any>this.subProjectForm).controls.profiledSheetingOrientation.setErrors(null);
        (<any>this.subProjectForm).controls.shearConnectionOrientation.setErrors(null);
      }

      return isInvalid ? { orientationMismatch: { valid: false } } : null;
    };
  }

  initializeSubProjectForm = (): void => {
    this.subProjectForm = this.fb.group({
      beamLocation: null,
      projectName: { value: null, disabled: true },
      subprojectName: null,
      loadCategory: null,
      liveLoadReduction: null,
      combinationFactor: null,
      beamDesign: null,
      beamLength: null,
      beamSpacingLeft: null,
      beamSpacingRight: null,
      leftOpening: null,
      leftOpeningPosition: null,
      rightOpening: null,
      rightOpeningPosition: null,
      slabType: null,
      slabThickness: null,
      haunchHeight: null,
      concreteStrengthUS: null,
      coverRequired: null,
      concreteDensity: null,
      aggregatesDensity: null,
      concreteClass: null,
      concreteStrength: null,
      concreteType: null,
      profileType: null,
      steelProfile: null,
      steelProfileCustomHeight: null,
      steelProfileCustomFlangeWidth: null,
      steelProfileCustomWebThickness: null,
      steelProfileCustomFlangeThickness: null,
      steelProfileCustomRootRadius: null,
      steelGrade: null,
      elasticImposed: null,
      steelProfileCustomSteelGradeYieldStrength: null,
      reinforcementType: null,
      profiledSheetingType: null,
      profiledSheetingCustomDeckDepth: null,
      profiledSheetingCustomThickness: null,
      profileSheetingCustomThicknessGage: null,
      profiledSheetingCustomTroughSpacing: null,
      profiledSheetingCustomBottomWidth: null,
      profiledSheetingCustomTopWidth: null,
      profiledSheetingCustomNumberRibStiffeners: null,
      profiledSheetingCustomRibStiffenerWidth: null,
      profiledSheetingCustomStiffenersSpacing: null,
      profiledSheetingCustomSurfaceWeight: null,
      profiledSheetingCustomYieldStrength: null,
      profiledSheetingOrientation: null,
      shearConnectionDegree: null,
      shearConnectionOrientation: null,
      shearConnectionType: null,
      userConnectionDegree: null,
      optimizationOption: null,
      constructionType: null,
      deflectionLimit: null,
      liveLoadPercentage: null,
      totalLoadDeflection: null,
      precamber: null,
      frequencyLimit: null,
      liveLoadInConstruction: null,
      permanentLoad: null,
      selfWeight: null,
      userSelfWeight: null,
      liveLoad: null,
      defaultLiveLoad: null,
      overrideSelfWeight: null,
      overrideLiveLoad: null,
      dampling: null,
      walkingExcitation: null,
      walkingActivity: null,
      rhythmicExcitationCheck: null,
      rhythmicActivity: null,
      uniformArrangement: null,
      steelStandardNZS: null,
      incrementalDeflectionCheck: null,
      performLateralTorsionBucklingCheck: null,
      permanentLoadFraction: null
    });
  }

  updateCustomDefinedConcreteRangeValidationRules(concreteType): void {
    switch (this.project.designCode) {
      case 1:
        this.validationValues.customDefinedConcreteRange.min = SubProjectComponent.CUSTOM_CONCRETE_METRIC.min;
        // tslint:disable-next-line:max-line-length
        this.validationValues.customDefinedConcreteRange.max = concreteType.id === 1 ? SubProjectComponent.CUSTOM_CONCRETE_METRIC.maxNormal : SubProjectComponent.CUSTOM_CONCRETE_METRIC.maxLight;
        break;
      case 2:
        if (this.project.unit === 1) {
          this.validationValues.customDefinedConcreteRange.min = SubProjectComponent.CUSTOM_CONCRETE_METRIC.min;
          // tslint:disable-next-line:max-line-length
          this.validationValues.customDefinedConcreteRange.max = concreteType.id === 1 ? SubProjectComponent.CUSTOM_CONCRETE_METRIC.maxNormal : SubProjectComponent.CUSTOM_CONCRETE_METRIC.maxLight;
        } else if (this.project.unit === 2) {
          this.validationValues.customDefinedConcreteRange.min = SubProjectComponent.CUSTOM_CONCRETE_IMPERIAL.min;
          // tslint:disable-next-line:max-line-length
          this.validationValues.customDefinedConcreteRange.max = concreteType.id === 1 ? SubProjectComponent.CUSTOM_CONCRETE_IMPERIAL.maxNormal : SubProjectComponent.CUSTOM_CONCRETE_IMPERIAL.maxLight;
        }
        break;
      case 3:
        this.validationValues.customDefinedConcreteRange.min = SubProjectComponent.CUSTOM_CONCRETE_ASNZS.min;
        this.validationValues.customDefinedConcreteRange.max = SubProjectComponent.CUSTOM_CONCRETE_ASNZS.max;
        break;
    }
  }

  setValidators = (unit: number): void => {
    switch (this.project.designCode) {
      case 1:
        // tslint:disable-next-line:max-line-length
        this.validationValues.concreteDensityRange = SubProjectComponent.CONCRETE_DENSITY_METRIC;
        this.validationValues.concreteDensityAggregatesRange = SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_METRIC;
        break;
      case 2:
        this.validationValues.concreteDensityRange = (unit === 1 ? SubProjectComponent.CONCRETE_DENSITY_METRIC : SubProjectComponent.CONCRETE_DENSITY_IMPERIAL);
        this.validationValues.concreteDensityAggregatesRange = (unit === 1 ? SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_METRIC : SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_IMPERIAL);
        break;
      case 3:
        this.validationValues.concreteDensityRange = SubProjectComponent.CONCRETE_DENSITY_ASNZS;
        this.validationValues.concreteDensityAggregatesRange = SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_ASNZS;
        break;
    }

    // tslint:disable-next-line:max-line-length
    this.validationValues.steelProfileCustomSteelGradeYieldStrength = (unit === 1 ? SubProjectComponent.CUSTOM_STEELGRADE_YIELD_STRENGTH_METRIC : SubProjectComponent.CUSTOM_STEELGRADE_YIELD_STRENGTH_IMPERIAL);
    // tslint:disable-next-line:max-line-length
    this.validationValues.beamLengthRange = (unit === 1 ? SubProjectComponent.BEAM_LENGTH_METRIC : SubProjectComponent.BEAM_LENGTH_IMPERIAL);
    // tslint:disable-next-line:max-line-length
    this.validationValues.profiledSheetingCustomYieldStrength = (unit === 1 ? SubProjectComponent.PROFILED_SHEETING_CUSTOM_YIELD_STRENGTH_METRIC : SubProjectComponent.PROFILED_SHEETING_CUSTOM_YIELD_STRENGTH_IMPERIAL);
    // tslint:disable-next-line:max-line-length
    this.validationValues.steelProfileCustomHeight = (unit === 1) ? SubProjectComponent.STEEL_PROFILE_CUSTOM_HEIGHT_METRIC : SubProjectComponent.STEEL_PROFILE_CUSTOM_HEIGHT_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.validationValues.steelProfileCustomRootRadius = (unit === 1) ? SubProjectComponent.STEEL_PROFILE_CUSTOM_ROOT_RADIUS_METRIC : SubProjectComponent.STEEL_PROFILE_CUSTOM_ROOT_RADIUS_IMPERIAL;
    this.validationValues.profiledSheetingCustomDeckDepth = (unit === 1) ? SubProjectComponent.PROFILED_SHEETING_CUSTOM_DECK_DEPTH_METRIC : SubProjectComponent.PROFILED_SHEETING_CUSTOM_DECK_DEPTH_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.validationValues.profiledSheetingCustomBottomWidth = (unit === 1) ? SubProjectComponent.PROFILED_SHEETING_CUSTOM_BOTTOM_WIDTH_METRIC : SubProjectComponent.PROFILED_SHEETING_CUSTOM_BOTTOM_WIDTH_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.validationValues.profiledSheetingCustomTopWidth = (unit === 1) ? SubProjectComponent.PROFILED_SHEETING_CUSTOM_TOP_WIDTH_METRIC : SubProjectComponent.PROFILED_SHEETING_CUSTOM_TOP_WIDTH_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.validationValues.profiledSheetingCustomTroughSpacing = (unit === 1) ? SubProjectComponent.PROFILED_SHEETING_CUSTOM_TROUGHSPACING_METRIC : SubProjectComponent.PROFILED_SHEETING_CUSTOM_TROUGHSPACING_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.validationValues.profiledSheetingCustomRibStiffenerWidth = (unit === 1) ? SubProjectComponent.PROFILED_SHEETING_CUSTOM_RIB_STIFFENER_WIDTH_METRIC : SubProjectComponent.PROFILED_SHEETING_CUSTOM_RIB_STIFFENER_WIDTH_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.validationValues.profiledSheetingCustomStiffenersSpacing = (unit === 1) ? SubProjectComponent.PROFILED_SHEETING_CUSTOM_STIFFENERS_SPACING_METRIC : SubProjectComponent.PROFILED_SHEETING_CUSTOM_STIFFENERS_SPACING_IMPERIAL;
    this.validationValues.steelProfileCustomWebThickness = (unit === 1) ? SubProjectComponent.STEEL_PROFILE_CUSTOM_WEB_THICKNESS_METRIC : SubProjectComponent.STEEL_PROFILE_CUSTOM_WEB_THICKNESS_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.validationValues.steelProfileCustomFlangeThickness = (unit === 1) ? SubProjectComponent.STEEL_PROFILE_CUSTOM_FLANGE_WIDTH_METRIC : SubProjectComponent.STEEL_PROFILE_CUSTOM_FLANGE_WIDTH_IMPERIAL;
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('subprojectName').setValidators([Validators.required, CustomValidators.rangeLength([3, 50]), this.subProjectNameValidator()]);
    this.subProjectForm.get('loadCategory').setValidators([Validators.required]);
    this.subProjectForm.get('combinationFactor').setValidators([Validators.required, CustomValidators.range([0, 1])]);
    this.subProjectForm.get('beamDesign').setValidators([Validators.required]);
    this.subProjectForm.get('beamLength').setValidators([Validators.required, CustomValidators.range([this.validationValues.beamLengthRange.min, this.validationValues.beamLengthRange.max])]);
    this.subProjectForm.get('beamSpacingLeft').setValidators([Validators.required, this.beamLeftSpacingValidator()]);
    this.subProjectForm.get('beamSpacingRight').setValidators([Validators.required, this.beamRightSpacingValidator()]);
    this.subProjectForm.get('leftOpening').setValidators([Validators.required]);
    this.subProjectForm.get('leftOpeningPosition').setValidators([Validators.required, this.leftOpeningPositionValidator()]);
    this.subProjectForm.get('rightOpening').setValidators([Validators.required]);
    this.subProjectForm.get('rightOpeningPosition').setValidators([Validators.required, this.rightOpeningPositionValidator()]);
    this.subProjectForm.get('slabType').setValidators([Validators.required]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('slabThickness').setValidators(unit === 1 ? [Validators.required, CustomValidators.min(50)] : [Validators.required, CustomValidators.min(2)]);
    this.subProjectForm.get('haunchHeight').setValidators([Validators.required, CustomValidators.min(0)]);
    this.subProjectForm.get('concreteStrengthUS').setValidators([Validators.required, this.concreteStrengthUSValidator()]);
    this.subProjectForm.get('coverRequired').setValidators([Validators.required, this.coverRequiredValidator()]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('concreteDensity').setValidators([Validators.required, CustomValidators.range([this.validationValues.concreteDensityRange.min, this.validationValues.concreteDensityRange.max])]);
    this.subProjectForm.get('aggregatesDensity').setValidators([Validators.required, CustomValidators.range([this.validationValues.concreteDensityAggregatesRange.min, this.validationValues.concreteDensityAggregatesRange.max])]);
    this.subProjectForm.get('concreteClass').setValidators([Validators.required]);
    this.subProjectForm.get('concreteStrength').setValidators([Validators.required]);
    this.subProjectForm.get('concreteType').setValidators([Validators.required]);
    this.subProjectForm.get('profileType').setValidators([Validators.required]);
    this.subProjectForm.get('steelProfile').setValidators([Validators.required]);

    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('steelProfileCustomFlangeWidth').setValidators([Validators.required, CustomValidators.min(this.validationValues.steelProfileCustomFlangeThickness.min), this.customFlangeWidthValidator()]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('steelProfileCustomWebThickness').setValidators([Validators.required, CustomValidators.min(this.validationValues.steelProfileCustomWebThickness.min)]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('steelProfileCustomFlangeThickness').setValidators(unit === 1 ? [Validators.required, CustomValidators.min(5)] : [Validators.required, CustomValidators.min(0.19)]);
    this.subProjectForm.get('steelGrade').setValidators([Validators.required]);
    this.subProjectForm.get('elasticImposed').setValidators([Validators.required]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('steelProfileCustomSteelGradeYieldStrength').setValidators([Validators.required, CustomValidators.range([this.validationValues.steelProfileCustomSteelGradeYieldStrength.min, this.validationValues.steelProfileCustomSteelGradeYieldStrength.max])]);
    this.subProjectForm.get('reinforcementType').setValidators([Validators.required]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomDeckDepth').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([this.validationValues.profiledSheetingCustomDeckDepth.min, this.validationValues.profiledSheetingCustomDeckDepth.max])]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomThickness').setValidators(unit === 1 ? [this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([0.5, 2])] : [this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([0.01, 0.08])]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomTroughSpacing').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([this.validationValues.profiledSheetingCustomTroughSpacing.min, this.validationValues.profiledSheetingCustomTroughSpacing.max]), this.customProfileSheetingTroughValidator()]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomBottomWidth').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([this.validationValues.profiledSheetingCustomBottomWidth.min, this.validationValues.profiledSheetingCustomBottomWidth.max, this.customProfiledSheetingBottomValidator()])]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomTopWidth').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([this.validationValues.profiledSheetingCustomTopWidth.min, this.validationValues.profiledSheetingCustomTopWidth.max])]);
    this.subProjectForm.get('profiledSheetingCustomNumberRibStiffeners').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.digits, CustomValidators.range([0, 2])]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomRibStiffenerWidth').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([this.validationValues.profiledSheetingCustomRibStiffenerWidth.min, this.validationValues.profiledSheetingCustomRibStiffenerWidth.max])]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomStiffenersSpacing').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([this.validationValues.profiledSheetingCustomStiffenersSpacing.min, this.validationValues.profiledSheetingCustomStiffenersSpacing.max])]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomSurfaceWeight').setValidators(unit === 1 ? [this.conditionalCustomProfiledSheetingValidator, CustomValidators.notEqual(0), CustomValidators.notEqual('0'), CustomValidators.range([0, 50])] : [this.conditionalCustomProfiledSheetingValidator, CustomValidators.notEqual(0), CustomValidators.notEqual('0'), CustomValidators.range([0, 10])]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomYieldStrength').setValidators([this.conditionalCustomProfiledSheetingValidator, CustomValidators.range([this.validationValues.profiledSheetingCustomYieldStrength.min, this.validationValues.profiledSheetingCustomYieldStrength.max])]);
    this.subProjectForm.get('profiledSheetingOrientation').setValidators([this.orientationValidator()]);
    this.subProjectForm.get('shearConnectionDegree').setValidators([Validators.required]);
    this.subProjectForm.get('shearConnectionOrientation').setValidators([Validators.required, this.orientationValidator()]);
    this.subProjectForm.get('shearConnectionType').setValidators([Validators.required, this.slabConnectorValidator()]);
    this.subProjectForm.get('userConnectionDegree').setValidators([Validators.required, CustomValidators.range([10, 100])]);
    this.subProjectForm.get('optimizationOption').setValidators([Validators.required]);
    this.subProjectForm.get('constructionType').setValidators([Validators.required]);
    this.subProjectForm.get('deflectionLimit').setValidators([Validators.required]);
    this.subProjectForm.get('liveLoadPercentage').setValidators([Validators.required]);
    this.subProjectForm.get('totalLoadDeflection').setValidators([Validators.required]);
    this.subProjectForm.get('precamber').setValidators([Validators.required]);
    this.subProjectForm.get('frequencyLimit').setValidators([Validators.required, CustomValidators.range([0, 10])]);
    this.subProjectForm.get('liveLoadInConstruction').setValidators([Validators.required, CustomValidators.min(0)]);
    this.subProjectForm.get('permanentLoad').setValidators([Validators.required, CustomValidators.min(0)]);
    this.subProjectForm.get('liveLoad').setValidators([CustomValidators.min(0)]);
    this.subProjectForm.get('permanentLoadFraction').setValidators([Validators.required, CustomValidators.range([0, 1])]);
    this.setBeamSpacingValidators(this.subProjectModel.beamGeometry.beamLocationId);

    this.calculationMessagesValuesRanges = {
      beamLengthUnit: this.unitSystem.lengthUnitTitle,
      beamLengthMin: this.validationValues.beamLengthRange.min,
      beamLengthMax: this.validationValues.beamLengthRange.max,
      steelStrengthMin: this.validationValues.steelProfileCustomSteelGradeYieldStrength.min,
      steelStrengthMax: this.validationValues.steelProfileCustomSteelGradeYieldStrength.max,
      concreteDensityMin: this.validationValues.concreteDensityRange.min,
      concreteDensityMax: this.validationValues.concreteDensityRange.max,
      concreteDensityUnit: this.unitSystem.densityUnitTitle,
      steelStrengthUnit: this.unitSystem.stressUnitForMaterialsTitle,
      leftSpacingMinLength: this.validationValues.beamSpacingLeft.max,
      leftSpacingMaxLength: this.validationValues.beamSpacingLeft.min,
      sheetingOrientationStrengthMax: this.validationValues.profiledSheetingCustomYieldStrength.max,
      sheetingOrientationStrengthMin: this.validationValues.profiledSheetingCustomYieldStrength.min,
      steelProfileWebThicknessMin: this.validationValues.steelProfileCustomWebThickness.min,
      steelProfileFlangeWidth: this.validationValues.steelProfileCustomFlangeThickness.min,
      dimensionUnitTitle: this.unitSystem.dimensionUnitTitle,
      incorectSlabThicknessIncreaseValue: this.project.unit === 1 ? 50 : 1.96,
      profileSheetingThicknessMin: this.project.unit === 1 ? 0.5 : 0.01,
      profileSheetingThicknessMax: this.project.unit === 1 ? 2 : 0.08,
      profileSheetingCustomTroughspacingMin: this.validationValues.profiledSheetingCustomTroughSpacing.min,
      profileSheetingCustomTroughspacingMax: this.validationValues.profiledSheetingCustomTroughSpacing.max,
      profileSheetingBottomWidthMin: this.validationValues.profiledSheetingCustomBottomWidth.min,
      profileSheetingBottomWidthMax: this.validationValues.profiledSheetingCustomBottomWidth.max,
      savMax: this.project.unit === 1 ? 200 : 7.87,
      profileSheetingCustomSurfaceWidthMin: 0,
      profileSheetingCustomSurfaceWidthMax: this.project.unit === 1 ? 50 : 10,
      surfaceWeightUnitTitle: this.unitSystem.surfaceWeightUnitTitle,
      profileSheetingThicknessSmallConnectors: this.project.unit === 1 ? 2 : 0.07,
      profileSheetingThicknessLargeConnectors: this.project.unit === 1 ? 1.5 : 0.05

    };
  }

  getConcreteClasses(nationalAnnexId: number, concreteClassId: number) {
    const concreteClasses = this.dropDownOptions.nationalConcreteClasses
      .filter(item => item.nationalAnnexId === nationalAnnexId)
      .map(x => x.concreteClassId);
    return this.concreteClasses.filter(item => concreteClasses.includes(item.id)).filter(c => c.concreteType.id === concreteClassId);
  }

  populateSubProjectForm = () => {
    let steelProfile = this.steelprofiles.filter(d => d.label === this.subProjectModel.steelProfile.profileName
      && d.steelProfileRange.dimension === this.unitSystem.dimensionUnitTitle
    )[0];
    if (steelProfile === undefined) {
      steelProfile = this.steelprofiles.filter(d => d.label === this.subProjectModel.steelProfile.profileName)[0];
    }
    if (this.project.designCode === 2) {
      this.steelProfilesPerRange = _.sortBy(this.steelprofiles.filter(p => p.steelProfileRange.id === steelProfile.steelProfileRange.id), o => o.id).reverse();
    } else {
      this.steelProfilesPerRange = this.steelprofiles.filter(p => p.steelProfileRange.id === steelProfile.steelProfileRange.id);
    }
    const concreteClass = this.concreteClasses.filter(item => item.id === this.subProjectModel.concreteSlab.concreteClassId)[0];
    this.concreteClassesPerConcreteType = this.getConcreteClasses(this.project.countryNationalAnnexes, concreteClass.concreteType.id);
    this.profileSheetings = this.getCurrentProfileSheetings(this.dropDownOptions, this.project.countryNationalAnnexes);
    this.loadCategories = this.loadCategories.filter(c => c.designCodeId === this.project.designCode);
    const loadCategory = this.loadCategories.filter(item => item.id === this.subProjectModel.loadCategory)[0];
    if (this.project.designCode === 3) {
      this.steelStandards = this.dropDownOptions.steelStandards.filter(i => i.countryId === this.project.countryNationalAnnexes);
      const steelStandard = this.dropDownOptions.steelStandards.find(i => i.id === this.subProjectModel.steelProfile.steelStandardNZS);
      this.subProjectForm.get('steelStandardNZS').setValue(steelStandard);
      this.steelGrades = this.dropDownOptions.steelGrades.filter(c => c.designCodeId === this.project.designCode && c.steelStandard === steelStandard.value);
    } else {
      this.steelGrades = this.dropDownOptions.steelGrades.filter(c => c.designCodeId === this.project.designCode);
    }

    let steelGrade = this.steelGrades.filter(item => item.id === this.subProjectModel.steelProfile.steelGradeId)[0];
    if (!steelGrade) {
      steelGrade = this.steelGrades[0];
    }

    this.concreteStrengths = this.concreteStrengths.filter(c => c.unitSystemId === this.project.unit && c.designCodeId === this.project.designCode);
    const concreteStrength = this.concreteStrengths.filter(item => item.id === this.subProjectModel.concreteSlab.concreteStrengthId)[0];

    this.constructionTypes = this.constructionTypes.filter(c => c.designCode === this.getStandardValue(this.project.designCode));
    this.reinforcementSteelGrades = this.reinforcementSteelGrades.filter(c => c.designCodeId === this.project.designCode);
    // tslint:disable-next-line:max-line-length
    const profileType = this.profileTypes.filter(item => item.id === steelProfile.steelProfileRange.id)[0];
    const reinforcementSteelGrade = this.reinforcementSteelGrades.filter(item => item.id === this.subProjectModel.reinforcement.steelGradeId)[0];
    // tslint:disable-next-line:max-line-length
    const nationalProfileTypeRanges = this.dropDownOptions.nationalSteelProfileRanges.filter(x => x.nationalAnnexId === this.project.countryNationalAnnexes).map(x => x.steelProfileRangeId);
    this.profileTypes = this.dropDownOptions.steelProfileRanges.filter(item => nationalProfileTypeRanges.includes(item.id));
    // tslint:disable-next-line:max-line-length
    this.totalDeflectionLimits = _.sortBy(this.deflectionLimits.filter(c => c.designCodeId === this.project.designCode && c.showInLiveLoad === true), o => o.id);
    this.totalLoadDeflections = _.sortBy(this.totalLoadDeflections.filter(c => c.designCodeId === this.project.designCode), o => o.id);
    this.subProjectForm.get('projectName').setValue(this.subProjectModel.projectName);
    this.subProjectForm.get('subprojectName').setValue(this.subProjectModel.name);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('loadCategory').setValue(loadCategory ? loadCategory : this.loadCategories[0], { emitEvent: false, emitViewToModelChange: false, emitModelToViewChange: true });
    this.subProjectForm.get('combinationFactor').setValue(this.subProjectModel.combinationFactor);
    this.subProjectForm.get('liveLoadReduction').setValue(this.subProjectModel.liveLoadReduction);

    const beamLocation = this.beamLocations.filter(item => item.id === this.subProjectModel.beamGeometry.beamLocationId)[0];
    this.subProjectForm.get('beamLocation').setValue(beamLocation);
    this.setBeamSpacingValidators(beamLocation.id);
    this.setBeamLabels(beamLocation.labelKey);
    this.setCustomSteelProfileValidators();
    this.subProjectForm.get('beamDesign').setValue(this.beamDesigns.filter(item => item.id === SubProjectComponent.DEFAULT_ID)[0]);
    this.subProjectForm.get('beamLength').setValue(this.subProjectModel.beamGeometry.beamLength);
    this.subProjectForm.get('beamSpacingLeft').setValue(this.subProjectModel.beamGeometry.leftSpacing);
    this.subProjectForm.get('beamSpacingRight').setValue(this.subProjectModel.beamGeometry.rightSpacing);
    // tslint:disable-next-line:max-line-length
    this.slabTypes = this.slabTypes.filter(item => item.designCode === this.getStandardValue(this.project.designCode));
    this.subProjectForm.get('slabType').setValue(this.slabTypes.filter(item => item.id === this.subProjectModel.beamGeometry.slabTypeId)[0]);
    this.subProjectForm.get('slabThickness').setValue(this.subProjectModel.concreteSlab.slabThickness);
    this.subProjectForm.get('leftOpening').setValue(this.subProjectModel.beamGeometry.leftOpening);
    this.subProjectForm.get('leftOpeningPosition').setValue(this.subProjectModel.beamGeometry.leftOpeningPosition);
    this.subProjectForm.get('rightOpening').setValue(this.subProjectModel.beamGeometry.rightOpening);
    this.subProjectForm.get('rightOpeningPosition').setValue(this.subProjectModel.beamGeometry.rightOpeningPosition);
    this.subProjectForm.get('haunchHeight').setValue(this.subProjectModel.concreteSlab.haunchHeight);
    this.subProjectForm.get('coverRequired').setValue(this.subProjectModel.concreteSlab.coverRequired);
    this.displayInfoMessage(this.subProjectModel.concreteSlab.coverRequired.toString());
    this.subProjectForm.get('concreteDensity').setValue(this.subProjectModel.concreteSlab.concreteDensity);
    if (this.subProjectModel.concreteSlab.aggregatesDensity == 0) {
      this.subProjectModel.concreteSlab.aggregatesDensity = this.project.unit === 1
        ? SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_METRIC.max
        : SubProjectComponent.CONCRETE_DENSITY_AGGREGATES_IMPERIAL.max;
    }
    this.subProjectForm.get('aggregatesDensity').setValue(this.subProjectModel.concreteSlab.aggregatesDensity);
    this.subProjectForm.get('concreteClass').setValue(concreteClass);
    this.subProjectForm.get('concreteStrength').setValue(concreteStrength ? concreteStrength : this.concreteStrengths[0]);
    this.subProjectForm.get('concreteStrengthUS').setValue(this.subProjectModel.concreteSlab.concreteStrengthUS);
    this.subProjectForm.get('concreteType').setValue(this.concreteTypes.filter(item => item.id === this.subProjectModel.concreteSlab.concreteTypeId)[0]);
    this.updateCustomDefinedConcreteRangeValidationRules(this.concreteTypes.filter(item => item.id === concreteClass.concreteType.id)[0]);
    this.subProjectForm.get('profileType').setValue(profileType);
    this.subProjectForm.get('steelProfile').setValue(steelProfile);
    this.subProjectForm.get('elasticImposed').setValue(this.subProjectModel.steelProfile.elasticImposed, { emitEvent: false });
    this.subProjectForm.get('walkingExcitation').setValue(this.subProjectModel.deformation.walkingExcitationCheck);
    this.subProjectForm.get('walkingActivity').setValue(
      this.walkingActivity.find(x => x.id === this.subProjectModel.deformation.walkingActivity
      ));
    this.subProjectForm.get('rhythmicExcitationCheck').setValue(this.subProjectModel.deformation.rhythmicExcitationCheck);
    this.onWalkingActivityChange(this.subProjectForm.get('walkingActivity').value);
    this.subProjectForm.get('rhythmicActivity').setValue(this.rhythmicActivity.find(x => x.id === this.subProjectModel.deformation.rhythmicActivity));
    this.subProjectForm.get('performLateralTorsionBucklingCheck').setValue(this.subProjectModel.deformation.performLateralTorsionBucklingCheck);
    this.onRytmicExcitationCheckchange(this.subProjectForm.get('rhythmicExcitationCheck').value);
    this.subProjectForm.get('steelGrade').setValue(steelGrade);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('reinforcementType').setValue(reinforcementSteelGrade);
    if (this.subProjectModel.beamGeometry.slabTypeId !== 1 && this.subProjectModel.profileSheeting && this.subProjectModel.profileSheeting.profileName) {
      const profileSheetingType = this.profileSheetings.filter(d => d.label === this.subProjectModel.profileSheeting.profileName)[0];
      this.subProjectForm.get('profiledSheetingType').setValue(profileSheetingType);
      // tslint:disable-next-line:max-line-length
      this.subProjectForm.get('profiledSheetingOrientation').setValue(this.sheetingOrientations.filter(item => item.id === this.subProjectModel.profileSheeting.sheetingOrientationId)[0]);
    }
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('shearConnectionDegree').setValue(this.shearConnectionDegrees.filter(item => item.id === this.subProjectModel.shearConnector.connectionDegreeId)[0]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('shearConnectionType').setValue(this.shearConnectorTypes.filter(item => item.id === this.subProjectModel.shearConnector.connectorTypeId)[0]);
    this.filteredConnectorOrientations = this.shearConnectorOrientationFiltered();
    this.subProjectForm.get('userConnectionDegree').setValue(this.subProjectModel.shearConnector.userConnectionDegree);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('shearConnectionOrientation').setValue(this.shearConnectorOrientations.filter(item => item.id === this.subProjectModel.shearConnector.connectorsOrientationId)[0]);
    this.subProjectForm.get('optimizationOption').setValue(!this.subProjectModel.shearConnector.optimizationOption);
    this.filteredConnectorTypes = this.shearConnectorTypesFiltered();
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('constructionType').setValue(this.constructionTypes.filter(item => item.id === this.subProjectModel.deformation.constructionTypeId)[0]);
    this.subProjectForm.get('deflectionLimit').setValue(this.deflectionLimits.filter(item => item.id === this.subProjectModel.deformation.compositeDeflectionLimit)[0]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('liveLoadPercentage').setValue(this.liveLoadPercentages.filter(item => item.id === this.subProjectModel.deformation.percentageLiveLoad)[0]);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('totalLoadDeflection').setValue(this.totalLoadDeflections.filter(item => item.id === this.subProjectModel.deformation.totalDeflectionLimit)[0]);
    this.subProjectForm.get('precamber').setValue(this.subProjectModel.deformation.precamber);
    this.subProjectForm.get('frequencyLimit').setValue(this.subProjectModel.deformation.frequencyLimit);
    this.damplings = this.dropDownOptions.damplings.filter(i => i.designCodeId === this.project.designCode);
    this.subProjectForm.get('dampling').setValue(this.damplings.find(x => x.id === this.subProjectModel.deformation.dampling));

    if (this.project.designCode === 2) {
      this.subProjectForm.get('walkingExcitation').setValue(this.subProjectModel.deformation.walkingExcitationCheck);
    }
    this.subProjectForm.get('liveLoadInConstruction').setValue(this.subProjectModel.load.loadCases[0].distributedSurfaceLoad);

    this.subProjectForm.get('steelProfileCustomHeight').setValue(this.subProjectModel.steelProfile.height);
    this.subProjectForm.get('steelProfileCustomFlangeWidth').setValue(this.subProjectModel.steelProfile.flangeWidth);
    this.subProjectForm.get('steelProfileCustomWebThickness').setValue(this.subProjectModel.steelProfile.webThickness);
    this.subProjectForm.get('steelProfileCustomFlangeThickness').setValue(this.subProjectModel.steelProfile.flangeThickness);
    this.subProjectForm.get('steelProfileCustomRootRadius').setValue(this.subProjectModel.steelProfile.rootRadius);

    this.subProjectForm.get('steelProfileCustomSteelGradeYieldStrength').setValue(this.subProjectModel.steelProfile.yieldStrength);

    this.subProjectForm.get('profiledSheetingCustomDeckDepth').setValue(this.subProjectModel.profileSheeting.ribHeight);
    this.subProjectForm.get('profiledSheetingCustomThickness').setValue(this.subProjectModel.profileSheeting.thickness);
    if (this.project.unit === 2) {
      this.subProjectForm.get('profileSheetingCustomThicknessGage').setValue(this.gages.find((item) => item.inch === this.subProjectModel.profileSheeting.thickness));
    }
    this.subProjectForm.get('profiledSheetingCustomTroughSpacing').setValue(this.subProjectModel.profileSheeting.pitch);
    this.subProjectForm.get('profiledSheetingCustomBottomWidth').setValue(this.subProjectModel.profileSheeting.ribBottomWidth);
    this.subProjectForm.get('profiledSheetingCustomTopWidth').setValue(this.subProjectModel.profileSheeting.ribTopWidth);
    this.subProjectForm.get('profiledSheetingCustomNumberRibStiffeners').setValue(this.subProjectModel.profileSheeting.numberRibStiffeners);
    this.subProjectForm.get('profiledSheetingCustomRibStiffenerWidth').setValue(this.subProjectModel.profileSheeting.ribStiffenerWidth);
    this.subProjectForm.get('profiledSheetingCustomStiffenersSpacing').setValue(this.subProjectModel.profileSheeting.stiffenersSpacing);
    this.subProjectForm.get('profiledSheetingCustomSurfaceWeight').setValue(this.subProjectModel.profileSheeting.surfaceWeight);
    this.subProjectForm.get('profiledSheetingCustomYieldStrength').setValue(this.subProjectModel.profileSheeting.yieldStrength);
    this.subProjectForm.get('permanentLoadFraction').setValue(this.subProjectModel.deformation.permanentLoadFraction);
    this.subProjectForm.get('incrementalDeflectionCheck').setValue(this.subProjectModel.deformation.incrementalDeflectionCheck);
    const o1 = this.getObservableDefaultCompositeSelfWeight();
    const o2 = this.getObservableDefaultLiveLoad();
    const combine = observableZip(o1, o2);
    const subscribe = combine.subscribe(defaultLoads => {
      this.calculatedSelfWeightNewtons = defaultLoads[0];
      this.calculatedLiveLoadNewtons = defaultLoads[1];
      this.calculatedSelfWeightDisplay = UnitHelper.roundLoadFromApi(defaultLoads[0], this.project.loadUnit);
      this.calculatedLiveLoadDisplay = UnitHelper.roundLoadFromApi(defaultLoads[1], this.project.loadUnit);
      this.subProjectForm.get('selfWeight').setValue(this.calculatedSelfWeightDisplay);
      this.subProjectForm.get('defaultLiveLoad').setValue(this.calculatedLiveLoadDisplay);
      if (this.calculatedSelfWeightDisplay !== this.subProjectModel.load.userCompositeSelfWeight
        && this.subProjectModel.load.userCompositeSelfWeight !== 0) {
        this.overrideSelfWeight = true;
        this.subProjectForm.get('overrideSelfWeight').setValue(true);
      } else {
        this.overrideSelfWeight = false;
        this.subProjectForm.get('overrideSelfWeight').setValue(false);
      }
      if (this.calculatedLiveLoadDisplay !== this.subProjectModel.load.loadCases[2].distributedSurfaceLoad &&
        this.subProjectModel.load.loadCases[2].distributedSurfaceLoad !== 0) {
        this.overrideLiveLoad = true;
        this.subProjectForm.get('overrideLiveLoad').setValue(true);
      } else {
        this.overrideLiveLoad = false;
        this.subProjectForm.get('overrideLiveLoad').setValue(false);
      }
      this.subProjectForm.get('permanentLoad').
        setValue(this.subProjectModel.load.loadCases[1].distributedSurfaceLoad);
      this.subProjectForm.get('liveLoad').
        setValue(this.subProjectModel.load.loadCases[2].distributedSurfaceLoad);
      this.subProjectForm.get('userSelfWeight').
        setValue(this.subProjectModel.load.userCompositeSelfWeight);
    });


    const connectorValid = this.isValidShearConnector();
    this.correctPointAndLineLoads();
    this.isFormValid();
  }

  populateCustomProfileSheeteing = () => {
    this.subProjectForm.get('profiledSheetingCustomDeckDepth').setValue(this.subProjectModel.profileSheeting.ribHeight);
    this.subProjectForm.get('profiledSheetingCustomThickness').setValue(this.subProjectModel.profileSheeting.thickness);
    this.subProjectForm.get('profiledSheetingCustomTroughSpacing').setValue(this.subProjectModel.profileSheeting.pitch);
    this.subProjectForm.get('profiledSheetingCustomBottomWidth').setValue(this.subProjectModel.profileSheeting.ribBottomWidth);
    this.subProjectForm.get('profiledSheetingCustomTopWidth').setValue(this.subProjectModel.profileSheeting.ribTopWidth);
    // tslint:disable-next-line:max-line-length
    this.subProjectForm.get('profiledSheetingCustomNumberRibStiffeners').setValue(this.subProjectModel.profileSheeting.numberRibStiffeners);
    this.subProjectForm.get('profiledSheetingCustomRibStiffenerWidth').setValue(this.subProjectModel.profileSheeting.ribStiffenerWidth);
    this.subProjectForm.get('profiledSheetingCustomStiffenersSpacing').setValue(this.subProjectModel.profileSheeting.stiffenersSpacing);
    this.subProjectForm.get('profiledSheetingCustomSurfaceWeight').setValue(this.subProjectModel.profileSheeting.surfaceWeight);
    this.subProjectForm.get('profiledSheetingCustomYieldStrength').setValue(this.subProjectModel.profileSheeting.yieldStrength);
  }

  correctPointAndLineLoads = () => {
    if ((this.subProjectModel.load.loadCases.filter(lc => lc.sequence === 0).length === 1)
      && (this.subProjectModel.load.loadCases.filter(lc => lc.sequence === 1).length === 1)
      && (this.subProjectModel.load.loadCases.filter(lc => lc.sequence === 2).length === 1)
      && (this.subProjectModel.load.loadCases.filter(lc => lc.sequence === 3).length === 1)) {
      const loadCases = [];
      for (const loadCase of this.subProjectModel.load.loadCases) {
        loadCases[loadCase.sequence] = loadCase;
      }
      this.subProjectModel.load.loadCases = _.cloneDeep(loadCases);
    } else {
      this.subProjectModel.load.loadCases[3].lineLoads = _.cloneDeep(this.subProjectModel.load.loadCases[1].lineLoads);
      this.subProjectModel.load.loadCases[3].pointLoads = _.cloneDeep(this.subProjectModel.load.loadCases[1].pointLoads);
      this.subProjectModel.load.loadCases[1].lineLoads = _.cloneDeep(this.subProjectModel.load.loadCases[0].lineLoads);
      this.subProjectModel.load.loadCases[1].pointLoads = _.cloneDeep(this.subProjectModel.load.loadCases[0].pointLoads);
      this.subProjectModel.load.loadCases[0].lineLoads = [];
      this.subProjectModel.load.loadCases[0].pointLoads = [];
      let tempSurfaceLoad;
      tempSurfaceLoad = this.subProjectModel.load.loadCases[3].distributedSurfaceLoad;
      this.subProjectModel.load.loadCases[3].distributedSurfaceLoad = this.subProjectModel.load.loadCases[1].distributedSurfaceLoad;
      this.subProjectModel.load.loadCases[1].distributedSurfaceLoad = tempSurfaceLoad;
      tempSurfaceLoad = this.subProjectModel.load.loadCases[1].distributedSurfaceLoad;
      this.subProjectModel.load.loadCases[1].distributedSurfaceLoad = this.subProjectModel.load.loadCases[0].distributedSurfaceLoad;
      this.subProjectModel.load.loadCases[0].distributedSurfaceLoad = tempSurfaceLoad;
      this.subProjectModel.load.loadCases[0].sequence = 0;
      this.subProjectModel.load.loadCases[1].sequence = 1;
      this.subProjectModel.load.loadCases[2].sequence = 2;
      this.subProjectModel.load.loadCases[3].sequence = 3;
    }
  }

  connectorHeight = (connector: any): number => {
    const labels = connector.label.split(' ');
    return +labels[1];
  }

  private validateConnectorForHaunch = (height: number, id: number): boolean => {
    if (id === 1 || id === 2) {
      return false; // X-HVB 40 or 50 not an option
    }
    const haunchHeight = this.project.unit === 1 ? +this.subProjectForm.value.haunchHeight : UnitHelper.convertInchToMm(this.subProjectForm.value.haunchHeight);
    const slabThickness = this.project.unit === 1 ? +this.subProjectForm.value.slabThickness : UnitHelper.convertInchToMm(this.subProjectForm.value.slabThickness);
    const minHeight = 40 + haunchHeight;
    const maxHeightForCover = slabThickness + (haunchHeight - 20);
    const maxHeightForWithOutCover = slabThickness + haunchHeight;
    if (this.subProjectForm.value.coverRequired === true) {
      if (height >= minHeight && height <= maxHeightForCover) {
        return true;
      }
    } else {
      if (height >= minHeight && height <= maxHeightForWithOutCover) {
        return true;
      }
    }
    console.log('Connector with id = ' + id + 'Not Valid');
    return false;
  }

  private validateConnectorWithOutHaunch = (height: number,
    minSlabThicknessWithCorrosion: number,
    minSlabThicknessWithOutCorrosion: number, id: number): boolean => {
    if (this.subProjectForm.value.slabType.value === 1 && (id === 1 || id === 2)) {
      return false; // X-HVB 40 or 50 not an option for profiled sheeting
    }
    const thickness = this.project.unit === 1 ? this.subProjectForm.value.slabThickness :
      UnitHelper.convertInchToMm(this.subProjectForm.value.slabThickness);
    if (this.subProjectForm.value.coverRequired === true) {
      if (thickness >= minSlabThicknessWithCorrosion) {
        return true;
      }
    } else {
      if (thickness >= minSlabThicknessWithOutCorrosion) {
        return true;
      }
    }
    return false;
  }

  private shearConnectorTypesFiltered = (): any[] => {
    const suitableConnectors = this.dropDownOptions.nationalShearConnectorTypes
      .filter(item => item.nationalAnnexId === this.project.countryNationalAnnexes)
      .map(x => x.shearConnectorTypeId);
    const shearConnectorFiltered = this.shearConnectorTypes.filter(item => suitableConnectors.includes(item.id));
    return shearConnectorFiltered.filter((connectorType) => {
      // tslint:disable-next-line:max-line-length
      // If Haunch Height
      const height = this.connectorHeight(connectorType);
      if (this.subProjectForm.value.haunchHeight > 0) {
        return this.validateConnectorForHaunch(height, connectorType.id);
      } else {
        return this.validateConnectorWithOutHaunch(height, connectorType.minSlabThicknessWithCorrosion,
          connectorType.minSlabThicknessWithOutCorrosion, connectorType.id);
      }
    });
  }

  private shearConnectorOrientationVisible = () => {
    const filtered = this.shearConnectorOrientationFiltered();
    if (filtered.length && filtered.length > 1) {
      return true;
    } else {
      return false;
    }
  }

  private shearConnectorOrientationFiltered = (): any[] => {
    // Orientation 1 - Parallel
    // Orientation 2 - Perpendicular
    // Orientation 1 - Duckwalk

    return this.shearConnectorOrientations.filter((orientations) => {
      // connector type is X-HVB 40 or 50 then Duckwalk
      if (!this.subProjectForm ||
        !this.subProjectForm.value ||
        !this.subProjectForm.value.shearConnectionType ||
        !this.subProjectForm.value.slabType) {
        return false;
      } else if (this.subProjectForm.value.shearConnectionType.id === 1 ||
        this.subProjectForm.value.shearConnectionType.id === 2) {
        // X-HVB 40 OR 50 only duckwalk is valid
        if (orientations.id === 3) {
          return true;
        } else {
          return false;
        }
      } else if (this.subProjectForm.value.slabType.value === 0 &&
        this.subProjectForm.value.shearConnectionType.id !== 1 &&
        this.subProjectForm.value.shearConnectionType.id !== 2) {
        // 1 is parallel if it is solid slab then we can only select longitudinal orientation
        if (orientations.id === 1) {
          return true;
        } else {
          return false;
        }
      } else if (this.subProjectForm.value.slabType.value === 1 &&
        this.subProjectForm.value.shearConnectionType.id !== 1 &&
        this.subProjectForm.value.shearConnectionType.id !== 2 &&
        orientations.id !== 3) {
        // Profiled Sheeting Orientation 2 is parallel
        // Sheeting orientation ids and Connector orientation ids do not match for parallel and perpendicular
        // Be mindful of that before changing the below code
        // If profiled Sheeting orientation is parallel then connector has to be longitudinal
        // If profiled Sheeting orientation is perpendicular then connector can be longitudinal or transverse
        if (this.subProjectForm.value.profiledSheetingOrientation.id === 2) {
          if (orientations.id === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
  }

  onLineLoadUpdated(event) {
    this.subProjectModel.load.loadCases[3].lineLoads = [];
    this.subProjectModel.load.loadCases[3].lineLoads.push(...event.liveLineLoads);
    this.subProjectModel.load.loadCases[1].lineLoads = [];
    this.subProjectModel.load.loadCases[1].lineLoads.push(...event.deadLineLoads);
    this.getLiveLineLoadsDrawing();
    this.getDeadLineLoadsDrawing();
    this.subProjectForm.markAsDirty();
  }

  onPointLoadUpdated(event) {
    this.subProjectModel.load.loadCases[3].pointLoads = [];
    this.subProjectModel.load.loadCases[3].pointLoads.push(...event.livePointLoads);
    this.subProjectModel.load.loadCases[1].pointLoads = [];
    this.subProjectModel.load.loadCases[1].pointLoads.push(...event.deadPointLoads);
    this.getLivePointLoadsDrawing();
    this.getDeadPointLoadsDrawing();
    this.subProjectForm.markAsDirty();
  }

  onSurfaceLoadUpdated(event) {
    this.subProjectModel.load.loadCases[3].distributedSurfaceLoad = event ? event : 0;
    if (this.subProjectModel.load.loadCases[3].distributedSurfaceLoad === 0) {
      this.surfaceLiveLoadsDrawing = null;
    } else {
      this.getLoadDrawing(3);
    }
    this.subProjectForm.markAsDirty();
  }

  private onGageThicknessChange(data) {
    if (data && data.inch) {
      this.subProjectForm.get('profiledSheetingCustomThickness').setValue(data.inch);
    }
  }

  private onSteelStandardChange(data: models.SteelStandards) {
    this.steelGrades = this.dropDownOptions.steelGrades.filter(p => p.steelStandard === data.value && p.designCodeId === this.project.designCode);
    this.subProjectForm.get('steelGrade').setValue(this.steelGrades[0]);
  }
}
